export default `
<?xml version="1.0" encoding="UTF-8"?>
<svg id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" viewBox="0 0 1827.3 1115.5">
  <!-- Generator: Adobe Illustrator 29.3.1, SVG Export Plug-In . SVG Version: 2.1.0 Build 151)  -->
  <defs>
    <style>
      .st0, .st1 {
        fill: none;
      }

      .st2 {
        fill: #e9993e;
      }

      .st3 {
        fill: #7cbf2d;
      }

      .st4 {
        fill: #c5a236;
      }

      .st5 {
        fill: #9af139;
      }

      .st6 {
        fill: #eaca52;
      }

      .st1 {
        stroke: #127ee0;
        stroke-dasharray: 1 12 1 12 1 12;
        stroke-linecap: round;
        stroke-linejoin: round;
        stroke-width: 2px;
      }

      .st7 {
        fill: #7fc42e;
      }

      .st8 {
        clip-path: url(#clippath-17);
      }

      .st9 {
        clip-path: url(#clippath-19);
      }

      .st10 {
        clip-path: url(#clippath-11);
      }

      .st11 {
        clip-path: url(#clippath-16);
      }

      .st12 {
        clip-path: url(#clippath-18);
      }

      .st13 {
        clip-path: url(#clippath-10);
      }

      .st14 {
        clip-path: url(#clippath-15);
      }

      .st15 {
        clip-path: url(#clippath-13);
      }

      .st16 {
        clip-path: url(#clippath-14);
      }

      .st17 {
        clip-path: url(#clippath-12);
      }

      .st18 {
        clip-path: url(#clippath-61);
      }

      .st19 {
        clip-path: url(#clippath-67);
      }

      .st20 {
        clip-path: url(#clippath-60);
      }

      .st21 {
        clip-path: url(#clippath-65);
      }

      .st22 {
        clip-path: url(#clippath-62);
      }

      .st23 {
        clip-path: url(#clippath-64);
      }

      .st24 {
        clip-path: url(#clippath-66);
      }

      .st25 {
        clip-path: url(#clippath-63);
      }

      .st26 {
        clip-path: url(#clippath-50);
      }

      .st27 {
        clip-path: url(#clippath-55);
      }

      .st28 {
        clip-path: url(#clippath-52);
      }

      .st29 {
        clip-path: url(#clippath-57);
      }

      .st30 {
        clip-path: url(#clippath-54);
      }

      .st31 {
        clip-path: url(#clippath-56);
      }

      .st32 {
        clip-path: url(#clippath-53);
      }

      .st33 {
        clip-path: url(#clippath-51);
      }

      .st34 {
        clip-path: url(#clippath-58);
      }

      .st35 {
        clip-path: url(#clippath-59);
      }

      .st36 {
        clip-path: url(#clippath-31);
      }

      .st37 {
        clip-path: url(#clippath-32);
      }

      .st38 {
        clip-path: url(#clippath-33);
      }

      .st39 {
        clip-path: url(#clippath-34);
      }

      .st40 {
        clip-path: url(#clippath-35);
      }

      .st41 {
        clip-path: url(#clippath-39);
      }

      .st42 {
        clip-path: url(#clippath-30);
      }

      .st43 {
        clip-path: url(#clippath-36);
      }

      .st44 {
        clip-path: url(#clippath-37);
      }

      .st45 {
        clip-path: url(#clippath-38);
      }

      .st46 {
        clip-path: url(#clippath-27);
      }

      .st47 {
        clip-path: url(#clippath-29);
      }

      .st48 {
        clip-path: url(#clippath-26);
      }

      .st49 {
        clip-path: url(#clippath-28);
      }

      .st50 {
        clip-path: url(#clippath-20);
      }

      .st51 {
        clip-path: url(#clippath-21);
      }

      .st52 {
        clip-path: url(#clippath-22);
      }

      .st53 {
        clip-path: url(#clippath-23);
      }

      .st54 {
        clip-path: url(#clippath-24);
      }

      .st55 {
        clip-path: url(#clippath-25);
      }

      .st56 {
        clip-path: url(#clippath-41);
      }

      .st57 {
        clip-path: url(#clippath-42);
      }

      .st58 {
        clip-path: url(#clippath-43);
      }

      .st59 {
        clip-path: url(#clippath-44);
      }

      .st60 {
        clip-path: url(#clippath-45);
      }

      .st61 {
        clip-path: url(#clippath-49);
      }

      .st62 {
        clip-path: url(#clippath-40);
      }

      .st63 {
        clip-path: url(#clippath-46);
      }

      .st64 {
        clip-path: url(#clippath-47);
      }

      .st65 {
        clip-path: url(#clippath-48);
      }

      .st66 {
        clip-path: url(#clippath-1);
      }

      .st67 {
        clip-path: url(#clippath-3);
      }

      .st68 {
        clip-path: url(#clippath-4);
      }

      .st69 {
        clip-path: url(#clippath-2);
      }

      .st70 {
        clip-path: url(#clippath-7);
      }

      .st71 {
        clip-path: url(#clippath-6);
      }

      .st72 {
        clip-path: url(#clippath-9);
      }

      .st73 {
        clip-path: url(#clippath-8);
      }

      .st74 {
        clip-path: url(#clippath-5);
      }

      .st75 {
        fill: #127ee0;
      }

      .st76 {
        fill: #9ad7db;
      }

      .st77 {
        fill: #2897ea;
      }

      .st78 {
        opacity: .1;
      }

      .st79 {
        fill: #2f71b6;
      }

      .st80 {
        clip-path: url(#clippath);
      }
    </style>
    <clipPath id="clippath">
      <polygon class="st0" points="633.7 583.2 664.7 601.1 689.4 586.9 658.4 569 633.7 583.2"/>
    </clipPath>
    <clipPath id="clippath-1">
      <rect class="st0" x="647.5" y="574.6" width="15.4" height="8.9"/>
    </clipPath>
    <clipPath id="clippath-2">
      <polygon class="st0" points="714.1 514.6 812.8 571.6 870.8 538.1 772.1 481.1 714.1 514.6"/>
    </clipPath>
    <clipPath id="clippath-3">
      <rect class="st0" x="793.3" y="510.4" width="24.2" height="14"/>
    </clipPath>
    <clipPath id="clippath-4">
      <rect class="st0" x="813.2" y="532.7" width="15.4" height="8.9"/>
    </clipPath>
    <clipPath id="clippath-5">
      <rect class="st0" x="746.9" y="507.8" width="30.8" height="14"/>
    </clipPath>
    <clipPath id="clippath-6">
      <polygon class="st0" points="696.1 789.6 794.8 846.6 852.8 813.1 754.1 756.1 696.1 789.6"/>
    </clipPath>
    <clipPath id="clippath-7">
      <rect class="st0" x="775.3" y="785.4" width="24.2" height="14"/>
    </clipPath>
    <clipPath id="clippath-8">
      <rect class="st0" x="795.2" y="807.7" width="15.4" height="8.9"/>
    </clipPath>
    <clipPath id="clippath-9">
      <rect class="st0" x="728.9" y="782.8" width="30.8" height="14"/>
    </clipPath>
    <clipPath id="clippath-10">
      <polygon class="st0" points="888.1 508.6 986.8 565.6 1044.8 532.1 946.1 475.1 888.1 508.6"/>
    </clipPath>
    <clipPath id="clippath-11">
      <rect class="st0" x="967.3" y="504.4" width="24.2" height="14"/>
    </clipPath>
    <clipPath id="clippath-12">
      <rect class="st0" x="987.2" y="526.7" width="15.4" height="8.9"/>
    </clipPath>
    <clipPath id="clippath-13">
      <rect class="st0" x="920.9" y="501.8" width="30.8" height="14"/>
    </clipPath>
    <clipPath id="clippath-14">
      <polygon class="st0" points="453.7 626 511.7 659.5 610.4 602.5 552.4 569 453.7 626"/>
    </clipPath>
    <clipPath id="clippath-15">
      <rect class="st0" x="546.2" y="583" width="30.8" height="14"/>
    </clipPath>
    <clipPath id="clippath-16">
      <rect class="st0" x="477.4" y="620.9" width="15.4" height="8.9"/>
    </clipPath>
    <clipPath id="clippath-17">
      <rect class="st0" x="524.7" y="631.9" width="15.4" height="8.9"/>
    </clipPath>
    <clipPath id="clippath-18">
      <rect class="st0" x="564.1" y="607.6" width="15.4" height="8.9"/>
    </clipPath>
    <clipPath id="clippath-19">
      <rect class="st0" x="517.8" y="594.3" width="24.2" height="14"/>
    </clipPath>
    <clipPath id="clippath-20">
      <polygon class="st0" points="390.2 796.8 421.2 814.7 445.9 800.5 415 782.6 390.2 796.8"/>
    </clipPath>
    <clipPath id="clippath-21">
      <rect class="st0" x="404.1" y="788.2" width="15.4" height="8.9"/>
    </clipPath>
    <clipPath id="clippath-22">
      <polygon class="st0" points="555.2 685.8 586.2 703.7 610.9 689.5 579.9 671.6 555.2 685.8"/>
    </clipPath>
    <clipPath id="clippath-23">
      <rect class="st0" x="569" y="677.2" width="15.4" height="8.9"/>
    </clipPath>
    <clipPath id="clippath-24">
      <polygon class="st0" points="841.2 713.8 872.2 731.7 896.9 717.5 865.9 699.6 841.2 713.8"/>
    </clipPath>
    <clipPath id="clippath-25">
      <rect class="st0" x="855" y="705.2" width="15.4" height="8.9"/>
    </clipPath>
    <clipPath id="clippath-26">
      <polygon class="st0" points="975.2 713.8 1006.2 731.7 1030.9 717.5 999.9 699.6 975.2 713.8"/>
    </clipPath>
    <clipPath id="clippath-27">
      <rect class="st0" x="989" y="705.2" width="15.4" height="8.9"/>
    </clipPath>
    <clipPath id="clippath-28">
      <polygon class="st0" points="1209.2 713.8 1240.2 731.7 1264.9 717.5 1234 699.6 1209.2 713.8"/>
    </clipPath>
    <clipPath id="clippath-29">
      <rect class="st0" x="1223" y="705.2" width="15.4" height="8.9"/>
    </clipPath>
    <clipPath id="clippath-30">
      <polygon class="st0" points="918.2 640.8 949.2 658.7 973.9 644.5 942.9 626.6 918.2 640.8"/>
    </clipPath>
    <clipPath id="clippath-31">
      <rect class="st0" x="932" y="632.2" width="15.4" height="8.9"/>
    </clipPath>
    <clipPath id="clippath-32">
      <polygon class="st0" points="660 630.2 778.4 698.6 896.8 630.2 778.4 561.9 660 630.2"/>
    </clipPath>
    <clipPath id="clippath-33">
      <polygon class="st0" points="823.4 444.4 854.3 462.3 879 448.1 848.1 430.2 823.4 444.4"/>
    </clipPath>
    <clipPath id="clippath-34">
      <rect class="st0" x="837.2" y="435.8" width="15.4" height="8.9"/>
    </clipPath>
    <clipPath id="clippath-35">
      <polygon class="st0" points="1446.4 590.4 1477.3 608.3 1502 594.1 1471.1 576.2 1446.4 590.4"/>
    </clipPath>
    <clipPath id="clippath-36">
      <rect class="st0" x="1460.2" y="581.8" width="15.4" height="8.9"/>
    </clipPath>
    <clipPath id="clippath-37">
      <polygon class="st0" points="1013.8 655.8 1112.5 712.8 1170.5 679.3 1071.8 622.3 1013.8 655.8"/>
    </clipPath>
    <clipPath id="clippath-38">
      <rect class="st0" x="1093" y="651.6" width="24.2" height="14"/>
    </clipPath>
    <clipPath id="clippath-39">
      <rect class="st0" x="1112.9" y="673.9" width="15.4" height="8.9"/>
    </clipPath>
    <clipPath id="clippath-40">
      <rect class="st0" x="1046.6" y="649" width="30.8" height="14"/>
    </clipPath>
    <clipPath id="clippath-41">
      <polygon class="st0" points="1090.8 550.8 1189.5 607.8 1247.5 574.3 1148.8 517.3 1090.8 550.8"/>
    </clipPath>
    <clipPath id="clippath-42">
      <rect class="st0" x="1170" y="546.6" width="24.2" height="14"/>
    </clipPath>
    <clipPath id="clippath-43">
      <rect class="st0" x="1189.9" y="568.9" width="15.4" height="8.9"/>
    </clipPath>
    <clipPath id="clippath-44">
      <rect class="st0" x="1123.6" y="544" width="30.8" height="14"/>
    </clipPath>
    <clipPath id="clippath-45">
      <polygon class="st0" points="1552.8 629.8 1632.3 675.7 1632.3 608.7 1610.8 596.3 1552.8 629.8"/>
    </clipPath>
    <clipPath id="clippath-46">
      <rect class="st0" x="1632" y="625.6" width="24.2" height="14"/>
    </clipPath>
    <clipPath id="clippath-47">
      <rect class="st0" x="1585.6" y="623" width="30.8" height="14"/>
    </clipPath>
    <clipPath id="clippath-48">
      <polygon class="st0" points="1275.8 474.8 1374.5 531.8 1432.5 498.3 1333.8 441.3 1275.8 474.8"/>
    </clipPath>
    <clipPath id="clippath-49">
      <rect class="st0" x="1355" y="470.6" width="24.2" height="14"/>
    </clipPath>
    <clipPath id="clippath-50">
      <rect class="st0" x="1374.9" y="492.9" width="15.4" height="8.9"/>
    </clipPath>
    <clipPath id="clippath-51">
      <rect class="st0" x="1308.6" y="468" width="30.8" height="14"/>
    </clipPath>
    <clipPath id="clippath-52">
      <polygon class="st0" points="512.4 838.2 570.4 871.6 669.1 814.7 611.1 781.2 512.4 838.2"/>
    </clipPath>
    <clipPath id="clippath-53">
      <rect class="st0" x="604.9" y="795.2" width="30.8" height="14"/>
    </clipPath>
    <clipPath id="clippath-54">
      <rect class="st0" x="536.1" y="833" width="15.4" height="8.9"/>
    </clipPath>
    <clipPath id="clippath-55">
      <rect class="st0" x="583.4" y="844.1" width="15.4" height="8.9"/>
    </clipPath>
    <clipPath id="clippath-56">
      <rect class="st0" x="622.8" y="819.8" width="15.4" height="8.9"/>
    </clipPath>
    <clipPath id="clippath-57">
      <rect class="st0" x="576.5" y="806.5" width="24.2" height="14"/>
    </clipPath>
    <clipPath id="clippath-58">
      <polygon class="st0" points="1300.4 707.2 1358.4 740.6 1457.1 683.7 1399.1 650.2 1300.4 707.2"/>
    </clipPath>
    <clipPath id="clippath-59">
      <rect class="st0" x="1392.9" y="664.2" width="30.8" height="14"/>
    </clipPath>
    <clipPath id="clippath-60">
      <rect class="st0" x="1324.1" y="702" width="15.4" height="8.9"/>
    </clipPath>
    <clipPath id="clippath-61">
      <rect class="st0" x="1371.4" y="713.1" width="15.4" height="8.9"/>
    </clipPath>
    <clipPath id="clippath-62">
      <rect class="st0" x="1410.8" y="688.8" width="15.4" height="8.9"/>
    </clipPath>
    <clipPath id="clippath-63">
      <rect class="st0" x="1364.5" y="675.5" width="24.2" height="14"/>
    </clipPath>
    <clipPath id="clippath-64">
      <polygon class="st0" points="1554.9 496.7 1612.9 530.1 1632.3 518.9 1632.3 452 1554.9 496.7"/>
    </clipPath>
    <clipPath id="clippath-65">
      <rect class="st0" x="1578.6" y="491.5" width="15.4" height="8.9"/>
    </clipPath>
    <clipPath id="clippath-66">
      <rect class="st0" x="1625.9" y="502.6" width="15.4" height="8.9"/>
    </clipPath>
    <clipPath id="clippath-67">
      <rect class="st0" x="1619" y="465" width="24.2" height="14"/>
    </clipPath>
  </defs>
  <polygon class="st76" points="664.7 601.1 633.7 583.2 658.4 569 689.4 586.9 664.7 601.1"/>
  <g class="st80">
    <g>
      <path class="st76" d="M656.3,568c-3.1,3.1-7.6,5.2-11.5,7.1-4.7,2.3-9.1,5.3-13.8,7.7,1.8,1.1,3.4,2.3,5.2,3.4,1.3.5,2.5,1.1,3.6,1.9l1.5,1c.9.4,1.8.9,2.6,1.6l28.3-16.4c-3.2-1.4-6.3-3.1-9.3-4.5-1.9-.8-3.7-1.8-5.5-2.9-.3.4-.5.7-.8,1"/>
      <path class="st76" d="M650.4,594.1c4.9,2.8,9.8,5.3,14.5,8.5,1-.4,1.9-.8,2.8-1.4,6.1-3.7,12.2-7.3,18.3-10.8,2.1-1.2,4.1-2.5,6.1-3.5-7.2-3.5-13.9-7.8-20.1-12.7l-28.2,16.3c2.3,1.1,4.5,2.2,6.7,3.5"/>
    </g>
  </g>
  <path d="M649.5,568.5h-2v10.6c0,.4.2.7.5.9l1,.6c.2,0,.3.2.5.2.2,0,.4,0,.5-.2l.8-.5c.4-.2.7-.7.7-1.2v-10.4h-2Z"/>
  <path class="st77" d="M649.5,558.1c-5,0-7.9,10.2-7.9,10.3v.3c.2,1.4,1.1,2.6,2.3,3.2,3.5,1.8,7.7,1.8,11.2,0,1.3-.6,2.1-1.8,2.3-3.2h0c0-.3-3-10.6-7.9-10.6"/>
  <path class="st75" d="M655,571.9c1.3-.6,2.1-1.8,2.3-3.2h0c-.6-2.3-1.5-4.5-2.7-6.5-.7-.6-1.6-.9-2.5-.9-5,0-7.9,10.2-7.9,10.3v.5c3.4,1.6,7.4,1.5,10.8-.2"/>
  <g class="st78">
    <g class="st66">
      <path class="st79" d="M660.7,582.3c-3.4,1.7-7.5,1.7-10.9,0-3-1.7-3-4.6,0-6.3,3.4-1.7,7.5-1.7,10.9,0,3,1.7,3,4.6,0,6.3"/>
    </g>
  </g>
  <polygon class="st76" points="812.8 571.6 870.8 538.1 772.1 481.1 714.1 514.6 812.8 571.6"/>
  <g class="st69">
    <g>
      <path class="st76" d="M713.8,515.9l.6.3c1.3.6,2.5,1.4,3.6,2.2,1.2.8,2.3,1.7,3.4,2.8,3.2,1.2,6.2,2.7,9.1,4.5v-22.2c-3.1,2.6-6.4,4.8-10,6.6-2.3,1.1-5.1,2-7.1,3.6,0,.4-.2.9-.3,1.5h0c0,.1,0,.1,0,.1.2.1.5.3.7.5"/>
      <path class="st76" d="M780.8,485.5c-3.1-1.9-6.6-3.8-9.9-5.9-.8.6-1.7,1.1-2.5,1.7-.4.3-.8.7-1.3,1-.9.6-1.9,1.1-2.7,1.7-.3.2-.6.4-.9.5-2.9,1.9-5.9,3.8-8.9,5.6-3.9,2.4-8.2,3.9-12.2,5.9-.6.5-1.2.9-1.9,1.2h55.4v-3.2c-.3-.1-.6-.3-.9-.5-4.7-2.9-9.6-5.2-14.3-8.1"/>
      <path class="st76" d="M733.2,527.2c.2.2,2.8,2,3.3,2.6,10,4.1,18.8,10.5,28.5,15.4,5.4,2.7,10.5,5.9,15.8,8.8,4.7,2.5,9.7,5,13.3,8.9h1.9v-65.5h-54.3c-2.1,1.7-4.5,3-7,4-.5.2-2.5,1.2-1.4.6l-1.8.9-1.1.6v21.4c1,.6,1.9,1.4,2.7,2.3"/>
      <path class="st76" d="M859.1,531c-.7-.4-1.5-.8-2.2-1.2-.7-.4-1.4-.9-2-1.5-11.8-6.6-22.9-14.8-35-20.7-.9-.4-1.7-1-2.4-1.7-.9-.3-1.7-.7-2.5-1.2-.2,0-.4,0-.5,0-1.7-.6-3.4-1.4-4.9-2.4-2.2-1.2-4.3-2.7-6.1-4.4-.1-.1-.2-.3-.4-.4h-7.1v65.5h34.7c2.1-2,4.6-3.7,7.3-4.9,2.6-1.3,4.8-3.2,7.3-4.6,4.8-2.6,9.8-5,14.6-7.7.5-.5,1-1,1.6-1.4v-12.1c-.8-.3-1.6-.7-2.3-1.1"/>
      <path class="st76" d="M817.6,570.3c3.6-2.2,7.1-4.6,10.4-7.1.2-.1.4-.2.6-.3h-32.2c.2.1.4.2.6.4h.3c1.2.5,2.3,1,3.3,1.6,1.3.7,2.9,1.7,4.2,2.5.7.4,4.2,2.4,5.7,4,.4.1.8.2,1.3.4l.5.3c.7-.1,1.3-.3,1.9-.6.7-.4,5.1-2.3,3.4-1.2"/>
      <path class="st76" d="M862.9,543.3c2.5-1.7,5.3-3.1,8.1-4.1l.5-1.2.2-.4c-1.5-.8-3.2-1.2-4.6-2-2.1-1.3-3.9-2.9-5.5-4.7v13.6c.5-.4.9-.7,1.4-1.1"/>
    </g>
  </g>
  <path d="M797.4,501.5h-3v16c0,.5.3,1.1.8,1.3l1.5.8c.5.3,1.1.3,1.6,0l1.2-.7c.6-.4,1-1.1,1-1.8v-15.7h-3Z"/>
  <path class="st77" d="M809.2,488c0,13.6-5.3,21.2-11.8,21.2s-11.8-7.8-11.8-21.2,5.3-21.2,11.8-21.2,11.8,7.6,11.8,21.2"/>
  <path class="st75" d="M809.2,488c0-7.4-1.6-13-4-16.5-.3,0-.6,0-.9,0-6.5,0-11.8,7.8-11.8,21.2s1.6,12.9,4.1,16.5c.3,0,.6,0,.9,0,6.5,0,11.8-7.6,11.8-21.2"/>
  <g class="st78">
    <g class="st67">
      <path class="st79" d="M814,522.3c-4.7,2.7-12.4,2.7-17.1,0s-4.7-7.2,0-9.9,12.4-2.7,17.1,0c4.7,2.7,4.7,7.2,0,9.9"/>
    </g>
  </g>
  <path d="M815.3,526.5h-2v10.6c0,.4.2.7.5.9l1,.6c.2,0,.4.1.5.2.2,0,.4,0,.5-.2l.8-.5c.4-.2.7-.7.7-1.2v-10.4h-2.1Z"/>
  <path class="st77" d="M815.3,516.2c-5,0-7.9,10.2-7.9,10.3v.3c.2,1.4,1,2.6,2.3,3.2,3.5,1.8,7.7,1.8,11.2,0,1.3-.6,2.2-1.8,2.3-3.2h0c0-.3-3-10.6-7.9-10.6"/>
  <path class="st75" d="M820.8,530c1.3-.6,2.2-1.8,2.3-3.2h0c-.6-2.3-1.5-4.5-2.7-6.5-.7-.6-1.6-.9-2.5-.9-5,0-7.9,10.2-7.9,10.3v.5c3.4,1.6,7.4,1.5,10.8-.2"/>
  <g class="st78">
    <g class="st68">
      <path class="st79" d="M826.4,540.3c-3.4,1.8-7.5,1.8-10.9,0-3-1.7-3-4.6,0-6.3,3.4-1.7,7.5-1.7,10.9,0,3,1.7,3,4.6,0,6.3"/>
    </g>
  </g>
  <path d="M745.8,483.3v31.6c0,.3.1.5.4.7l.7.4c.1,0,.3.1.4.1.1,0,.3,0,.4-.1l.6-.3c.3-.2.5-.5.5-.9v-31.4h-3.1Z"/>
  <path class="st77" d="M747.3,452.7c-7.5,0-11.9,36.6-12,36.8,0,0,0,.1,0,.2v.2c0,1.7,1.2,3.4,3.5,4.8,4.7,2.7,12.2,2.7,16.9,0,2.3-1.3,3.4-3,3.5-4.8h0c0-.5-4.5-37.3-12-37.3"/>
  <path class="st75" d="M755.8,494.7c2.3-1.3,3.5-3,3.5-4.8h0c0-.4-2.6-21.7-7.1-31.9h0c-7.5,0-11.9,36.6-12,36.8v.3h0c4.7,2.1,11.4,2,15.6-.5"/>
  <g class="st78">
    <g class="st74">
      <path class="st79" d="M774.2,509.9c-4.7-2.7-12.4-2.7-17.1,0-1.6.8-2.8,2.2-3.4,3.9h-6.7v2.2h6.8c.6,1.6,1.8,3,3.4,3.8,4.7,2.7,12.4,2.7,17.1,0s4.7-7.2,0-9.9"/>
    </g>
  </g>
  <polygon class="st76" points="794.8 846.6 852.8 813.1 754.1 756.1 696.1 789.6 794.8 846.6"/>
  <g class="st71">
    <g>
      <path class="st76" d="M695.8,790.9l.6.3c1.3.6,2.5,1.4,3.6,2.2,1.2.8,2.3,1.7,3.4,2.8,3.2,1.2,6.2,2.7,9.1,4.5v-22.2c-3.1,2.6-6.4,4.8-10,6.6-2.3,1.1-5.1,2-7.1,3.7,0,.4-.2.9-.3,1.5h0c0,.1,0,.1,0,.1.2.1.5.3.7.5"/>
      <path class="st76" d="M762.8,760.5c-3.1-1.9-6.6-3.8-9.9-5.9-.8.6-1.7,1.2-2.5,1.7-.4.3-.8.7-1.3,1-.9.6-1.9,1.1-2.7,1.7-.3.2-.6.4-.9.5-2.9,1.9-5.9,3.8-8.9,5.6-3.9,2.4-8.2,3.9-12.2,5.9-.6.5-1.2.9-1.9,1.2h55.4v-3.2c-.3-.1-.6-.3-.9-.5-4.7-2.9-9.6-5.2-14.3-8.1"/>
      <path class="st76" d="M715.2,802.2c.2.2,2.8,2,3.3,2.6,10,4.1,18.8,10.5,28.5,15.4,5.4,2.7,10.5,5.9,15.8,8.8,4.7,2.5,9.7,5,13.3,8.9h1.9v-65.5h-54.3c-2.1,1.7-4.5,3-7,4-.5.2-2.5,1.2-1.4.6l-1.8.9-1.1.6v21.4c1,.6,1.9,1.4,2.7,2.3"/>
      <path class="st76" d="M841.1,806c-.7-.4-1.5-.8-2.2-1.2-.7-.4-1.4-.9-2-1.5-11.8-6.6-22.9-14.8-35-20.7-.9-.4-1.7-1-2.4-1.7-.9-.3-1.7-.7-2.5-1.2-.2,0-.4,0-.5,0-1.7-.6-3.4-1.4-4.9-2.4-2.2-1.2-4.3-2.7-6.1-4.4-.1-.1-.2-.3-.4-.4h-7.1v65.5h34.7c2.1-2,4.6-3.7,7.3-4.9,2.6-1.3,4.8-3.2,7.3-4.6,4.8-2.6,9.8-5,14.6-7.7.5-.5,1-1,1.6-1.4v-12.1c-.8-.3-1.6-.7-2.3-1.1"/>
      <path class="st76" d="M799.6,845.3c3.6-2.2,7.1-4.6,10.4-7.1.2-.1.4-.2.6-.3h-32.2c.2.1.4.2.6.4h.3c1.2.5,2.3,1,3.3,1.6,1.3.7,2.9,1.7,4.2,2.5.7.4,4.2,2.4,5.7,4,.4.1.8.2,1.3.4l.5.3c.7-.1,1.3-.3,1.9-.6.7-.4,5.1-2.3,3.4-1.2"/>
      <path class="st76" d="M844.9,818.3c2.5-1.7,5.3-3.1,8.1-4.1l.5-1.2.2-.4c-1.5-.8-3.2-1.2-4.6-2-2.1-1.3-3.9-2.9-5.5-4.7v13.6c.5-.4.9-.7,1.4-1.1"/>
    </g>
  </g>
  <path d="M779.4,776.5h-3v16c0,.5.3,1.1.8,1.3l1.5.8c.5.3,1.1.3,1.6,0l1.2-.7c.6-.4,1-1.1,1-1.8v-15.7h-3Z"/>
  <path class="st77" d="M791.2,763c0,13.6-5.3,21.2-11.8,21.2s-11.8-7.8-11.8-21.2,5.3-21.2,11.8-21.2,11.8,7.6,11.8,21.2"/>
  <path class="st75" d="M791.2,763c0-7.4-1.6-13-4-16.5-.3,0-.6,0-.9,0-6.5,0-11.8,7.8-11.8,21.2s1.6,12.9,4.1,16.5c.3,0,.6,0,.9,0,6.5,0,11.8-7.6,11.8-21.2"/>
  <g class="st78">
    <g class="st70">
      <path class="st79" d="M796,797.3c-4.7,2.7-12.4,2.7-17.1,0s-4.7-7.2,0-9.9,12.4-2.7,17.1,0,4.7,7.2,0,9.9"/>
    </g>
  </g>
  <path d="M797.3,801.5h-2v10.6c0,.4.2.7.5.9l1,.6c.2,0,.4.1.5.2.2,0,.4,0,.5-.2l.8-.5c.4-.2.7-.7.7-1.2v-10.4h-2.1Z"/>
  <path class="st77" d="M797.3,791.2c-5,0-7.9,10.2-7.9,10.3v.3c.2,1.4,1,2.6,2.3,3.2,3.5,1.8,7.7,1.8,11.2,0,1.3-.6,2.2-1.8,2.3-3.2h0c0-.3-3-10.6-7.9-10.6"/>
  <path class="st75" d="M802.8,805c1.3-.6,2.2-1.8,2.3-3.2h0c-.6-2.3-1.5-4.5-2.7-6.5-.7-.6-1.6-.9-2.5-.9-5,0-7.9,10.2-7.9,10.3v.5c3.4,1.6,7.4,1.5,10.8-.2"/>
  <g class="st78">
    <g class="st73">
      <path class="st79" d="M808.4,815.3c-3.4,1.8-7.5,1.8-10.9,0-3-1.7-3-4.6,0-6.3,3.4-1.7,7.5-1.7,10.9,0,3,1.7,3,4.6,0,6.3"/>
    </g>
  </g>
  <path d="M727.8,758.3v31.6c0,.3.1.5.4.7l.7.4c.1,0,.3.1.4.1.1,0,.3,0,.4-.1l.6-.3c.3-.2.5-.5.5-.9v-31.4h-3.1Z"/>
  <path class="st77" d="M729.3,727.7c-7.5,0-11.9,36.6-12,36.8,0,0,0,.1,0,.2v.2c0,1.7,1.2,3.4,3.5,4.8,4.7,2.7,12.2,2.7,16.9,0,2.3-1.3,3.4-3,3.5-4.8h0c0-.5-4.5-37.3-12-37.3"/>
  <path class="st75" d="M737.8,769.8c2.3-1.3,3.5-3,3.5-4.8h0c0-.4-2.6-21.7-7.1-31.9h0c-7.5,0-11.9,36.6-12,36.8v.5c4.7,2,11.4,1.8,15.6-.6"/>
  <g class="st78">
    <g class="st72">
      <path class="st79" d="M756.2,784.9c-4.7-2.7-12.4-2.7-17.1,0-1.6.8-2.8,2.2-3.4,3.9h-6.7v2.2h6.8c.6,1.6,1.8,3,3.4,3.8,4.7,2.7,12.4,2.7,17.1,0s4.7-7.2,0-9.9"/>
    </g>
  </g>
  <polygon class="st76" points="986.8 565.6 1044.8 532.1 946.1 475.1 888.1 508.6 986.8 565.6"/>
  <g class="st13">
    <g>
      <path class="st76" d="M887.8,509.9l.6.3c1.3.6,2.5,1.4,3.6,2.2,1.2.8,2.3,1.7,3.4,2.8,3.2,1.2,6.2,2.7,9.1,4.5v-22.2c-3.1,2.6-6.4,4.8-10,6.6-2.3,1.1-5.1,2-7.1,3.6,0,.4-.2.9-.3,1.5h0c0,.1,0,.1,0,.1.2.1.5.3.7.5"/>
      <path class="st76" d="M954.8,479.5c-3.1-1.9-6.6-3.8-9.9-5.9-.8.6-1.7,1.1-2.5,1.7-.4.3-.8.7-1.3,1-.9.6-1.9,1.1-2.7,1.7-.3.2-.6.4-.9.5-2.9,1.9-5.9,3.8-8.9,5.6-3.9,2.4-8.2,3.9-12.2,5.9-.6.5-1.2.9-1.9,1.2h55.4v-3.2c-.3-.1-.6-.3-.9-.5-4.7-2.9-9.6-5.2-14.3-8.1"/>
      <path class="st76" d="M907.2,521.2c.2.2,2.8,2,3.3,2.6,10,4.1,18.8,10.5,28.5,15.4,5.4,2.7,10.5,5.9,15.8,8.8,4.7,2.5,9.7,5,13.3,8.9h1.9v-65.5h-54.3c-2.1,1.7-4.5,3-7,4-.5.2-2.5,1.2-1.4.6l-1.8.9-1.1.6v21.4c1,.6,1.9,1.4,2.7,2.3"/>
      <path class="st76" d="M1033.2,525c-.7-.4-1.5-.8-2.2-1.2-.7-.4-1.4-.9-2-1.5-11.8-6.6-22.9-14.8-35-20.7-.9-.4-1.7-1-2.4-1.7-.9-.3-1.7-.7-2.5-1.2-.2,0-.4,0-.5,0-1.7-.6-3.4-1.4-4.9-2.4-2.2-1.2-4.3-2.7-6.1-4.4-.1-.1-.2-.3-.4-.4h-7.1v65.5h34.7c2.1-2,4.6-3.7,7.3-4.9,2.6-1.3,4.8-3.2,7.3-4.6,4.8-2.6,9.8-5,14.6-7.7.5-.5,1-1,1.6-1.4v-12.1c-.8-.3-1.6-.7-2.3-1.1"/>
      <path class="st76" d="M991.6,564.3c3.6-2.2,7.1-4.6,10.4-7.1.2-.1.4-.2.6-.3h-32.3c.2.1.4.2.6.4h.3c1.2.5,2.3,1,3.3,1.6,1.3.7,2.9,1.7,4.2,2.5.7.4,4.2,2.4,5.7,4,.4.1.8.2,1.3.4l.5.3c.7-.1,1.3-.3,1.9-.6.7-.4,5.1-2.3,3.4-1.2"/>
      <path class="st76" d="M1036.9,537.3c2.5-1.7,5.2-3.1,8.1-4.1l.5-1.2.2-.4c-1.5-.8-3.2-1.2-4.6-2-2.1-1.3-3.9-2.9-5.6-4.7v13.6c.5-.4.9-.7,1.4-1.1"/>
    </g>
  </g>
  <path d="M971.4,495.5h-3v16c0,.6.3,1.1.8,1.3l1.5.8c.5.3,1.1.3,1.6,0l1.2-.7c.6-.4,1-1.1,1-1.8v-15.7h-3Z"/>
  <path class="st77" d="M983.2,482c0,13.6-5.3,21.2-11.8,21.2s-11.8-7.8-11.8-21.2,5.3-21.2,11.8-21.2,11.8,7.6,11.8,21.2"/>
  <path class="st75" d="M983.2,482c0-7.4-1.6-13-4-16.5-.3,0-.6,0-.9,0-6.5,0-11.8,7.8-11.8,21.2s1.6,12.9,4.1,16.5c.3,0,.6,0,.9,0,6.5,0,11.8-7.6,11.8-21.2"/>
  <g class="st78">
    <g class="st10">
      <path class="st79" d="M988,516.3c-4.7,2.7-12.4,2.7-17.1,0s-4.7-7.1,0-9.9,12.4-2.7,17.1,0,4.7,7.2,0,9.9"/>
    </g>
  </g>
  <path d="M989.3,520.5h-2v10.6c0,.4.2.7.5.9l1,.6c.2,0,.4.1.5.2.2,0,.4,0,.5-.2l.8-.5c.4-.2.7-.7.7-1.2v-10.4h-2.1Z"/>
  <path class="st77" d="M989.3,510.2c-5,0-7.9,10.2-7.9,10.3v.3c.2,1.4,1,2.6,2.3,3.2,3.5,1.8,7.7,1.8,11.2,0,1.3-.6,2.2-1.8,2.3-3.2h0c0-.3-3-10.6-7.9-10.6"/>
  <path class="st75" d="M994.8,524c1.3-.6,2.2-1.8,2.3-3.2h0c-.6-2.3-1.5-4.5-2.7-6.5-.7-.6-1.6-.9-2.5-.9-5,0-7.9,10.2-7.9,10.3v.5c3.4,1.6,7.4,1.5,10.8-.2"/>
  <g class="st78">
    <g class="st17">
      <path class="st79" d="M1000.4,534.3c-3.4,1.8-7.5,1.8-10.9,0-3-1.7-3-4.6,0-6.3,3.4-1.7,7.5-1.7,10.9,0,3,1.7,3,4.6,0,6.3"/>
    </g>
  </g>
  <path d="M919.8,477.3v31.6c0,.3.1.5.4.7l.7.4c.1,0,.3.1.4.1.1,0,.3,0,.4-.1l.6-.4c.3-.2.5-.5.5-.9v-31.4h-3.1Z"/>
  <path class="st77" d="M921.3,446.7c-7.5,0-11.9,36.6-12,36.8,0,0,0,.1,0,.2v.2c0,1.7,1.2,3.4,3.5,4.8,4.7,2.7,12.2,2.7,16.9,0,2.3-1.3,3.5-3,3.5-4.8h0c0-.5-4.5-37.3-12-37.3"/>
  <path class="st75" d="M929.8,488.7c2.3-1.3,3.5-3,3.5-4.8h0c0-.4-2.6-21.7-7.1-31.9h0c-7.5,0-11.9,36.6-12,36.8v.3h0c4.7,2.1,11.4,2,15.6-.5"/>
  <g class="st78">
    <g class="st15">
      <path class="st79" d="M948.2,503.9c-4.7-2.7-12.4-2.7-17.1,0-1.6.8-2.8,2.2-3.4,3.9h-6.7v2.2h6.8c.6,1.6,1.8,3,3.4,3.8,4.7,2.7,12.4,2.7,17.1,0s4.7-7.2,0-9.9"/>
    </g>
  </g>
  <polygon class="st76" points="511.7 659.5 453.7 626 552.4 569 610.4 602.5 511.7 659.5"/>
  <g class="st16">
    <g>
      <path class="st76" d="M610.7,603.8l-.6.3c-1.3.6-2.5,1.4-3.6,2.2-1.2.8-2.3,1.7-3.3,2.8-3.2,1.2-6.2,2.7-9.1,4.5v-22.2c3.1,2.6,6.4,4.8,10,6.6,2.3,1.1,5.1,2,7.1,3.7,0,.4.2.9.3,1.5h0c0,.1,0,.1,0,.1-.5.3-.7.4-.7.5"/>
      <path class="st76" d="M543.7,573.5c3.1-1.9,6.6-3.8,9.9-5.9.8.6,1.7,1.1,2.5,1.7.4.3.8.7,1.3,1,.9.6,1.9,1.1,2.7,1.7.3.2.6.4.9.5,3,1.9,5.9,3.8,8.9,5.6,3.9,2.4,8.2,3.9,12.2,5.9.6.5,1.2.9,1.9,1.2h-55.5v-3.2c.3-.2.6-.3.9-.5,4.7-2.9,9.6-5.2,14.3-8.1"/>
      <path class="st76" d="M591.3,615c-.2.2-2.7,2-3.3,2.6-10,4.1-18.8,10.5-28.5,15.4-5.4,2.7-10.5,5.9-15.8,8.8-4.7,2.5-9.7,5-13.3,8.9h-1.9v-65.5h54.3c2.1,1.7,4.4,3,6.9,4,.5.2,2.5,1.2,1.4.6.6.3,1.2.6,1.7.9l1.1.5v21.4c-1,.6-1.9,1.4-2.7,2.3"/>
      <path class="st76" d="M465.4,618.9c.7-.4,1.5-.8,2.2-1.2.7-.4,1.4-.9,2-1.5,11.8-6.6,22.9-14.8,35-20.7.9-.4,1.7-1,2.4-1.7.9-.3,1.7-.7,2.5-1.2.2,0,.4,0,.5,0,1.7-.6,3.4-1.4,4.9-2.3,2.2-1.2,4.3-2.7,6.1-4.4.1-.1.2-.3.4-.4h7.2v65.5h-34.7c-2.1-2-4.6-3.7-7.3-4.9-2.6-1.3-4.8-3.2-7.3-4.6-4.8-2.6-9.8-5-14.6-7.7-.5-.5-1-1-1.6-1.4v-12.2c.8-.3,1.6-.7,2.3-1.1"/>
      <path class="st76" d="M507,658.2c-3.6-2.2-7.1-4.6-10.4-7.1-.2-.1-.4-.2-.6-.3h32.3c-.2.1-.4.2-.6.4h-.3c-1.2.5-2.3,1-3.3,1.6-1.3.7-2.9,1.7-4.2,2.5-.7.4-4.2,2.4-5.7,4l-1.3.4-.5.3c-.7-.1-1.3-.3-1.9-.6-.7-.4-5.1-2.3-3.4-1.2"/>
      <path class="st76" d="M461.6,631.2c-2.5-1.7-5.2-3.1-8.1-4.1-.1-.4-.3-.8-.5-1.2-.2-.6,0-.2-.2-.4,1.5-.8,3.2-1.2,4.6-2,2.1-1.3,3.9-2.9,5.5-4.7v13.6c-.5-.4-.9-.7-1.4-1.1"/>
    </g>
  </g>
  <path d="M545.1,558.5v31.6c0,.3.1.5.4.7l.8.4c.1,0,.3.1.4.1.1,0,.3,0,.4-.1l.6-.3c.3-.2.5-.5.5-.9v-31.4h-3.1Z"/>
  <path class="st77" d="M546.7,527.9c-7.5,0-11.9,36.6-12,36.8v.2s0,0,0,.1h0c0,1.8,1.2,3.6,3.5,4.9,4.7,2.7,12.2,2.7,16.9,0,2.3-1.3,3.5-3,3.5-4.8h0c0-.5-4.4-37.3-12-37.3"/>
  <path class="st75" d="M555.1,570c2.3-1.3,3.5-3,3.5-4.8h0c0-.4-2.6-21.7-7.1-31.9h-.1c-7.5,0-11.9,36.6-12,36.8v.3s0,0,0,.1h0c4.7,2,11.4,1.8,15.6-.6"/>
  <g class="st78">
    <g class="st14">
      <path class="st79" d="M573.5,585c-4.7-2.7-12.4-2.7-17.1,0-1.6.8-2.9,2.2-3.4,3.9h-6.8v2.2h6.8c.6,1.6,1.8,3,3.4,3.8,4.7,2.7,12.4,2.7,17.1,0s4.7-7.2,0-9.9"/>
    </g>
  </g>
  <path d="M479.4,614.7h-2v10.6c0,.4.2.7.5.9l1,.6c.3.2.7.2,1.1,0l.8-.5c.4-.2.7-.7.7-1.2v-10.4h-2.1Z"/>
  <path class="st77" d="M479.4,604.3c-5,0-7.9,10.2-7.9,10.3v.3c.2,1.4,1,2.6,2.3,3.2,3.5,1.8,7.7,1.8,11.2,0,1.3-.6,2.2-1.8,2.3-3.2h0c0-.3-2.9-10.6-7.9-10.6"/>
  <path class="st75" d="M485,618.1c1.3-.6,2.2-1.8,2.3-3.2h0c-.6-2.3-1.5-4.5-2.7-6.5-.7-.6-1.6-.9-2.5-.9-5,0-7.9,10.2-7.9,10.3,0,0,0,0,0,.1v.4c3.4,1.6,7.4,1.5,10.8-.2"/>
  <g class="st78">
    <g class="st11">
      <path class="st79" d="M490.6,628.5c-3.4,1.7-7.5,1.7-10.9,0-3-1.7-3-4.6,0-6.3,3.4-1.7,7.5-1.7,10.9,0,3,1.7,3,4.6,0,6.3"/>
    </g>
  </g>
  <path d="M526.7,625.7h-2v10.6c0,.4.2.7.5.9l1,.6c.3.2.7.2,1.1,0l.8-.5c.4-.2.7-.7.7-1.2v-10.4h-2.1Z"/>
  <path class="st77" d="M526.7,615.4c-5,0-7.9,10.2-7.9,10.3v.3c.2,1.4,1,2.6,2.3,3.2,3.5,1.8,7.7,1.8,11.2,0,1.3-.6,2.2-1.8,2.3-3.2h0c0-.3-2.9-10.6-7.9-10.6"/>
  <path class="st75" d="M532.2,629.1c1.3-.6,2.2-1.8,2.3-3.2h0c-.6-2.3-1.5-4.5-2.7-6.5-.7-.6-1.6-.9-2.5-.9-5,0-7.9,10.2-7.9,10.3,0,0,0,0,0,.1v.4c3.4,1.6,7.4,1.5,10.8-.2"/>
  <g class="st78">
    <g class="st8">
      <path class="st79" d="M537.9,639.5c-3.4,1.7-7.5,1.7-10.9,0-3-1.7-3-4.6,0-6.3,3.4-1.7,7.5-1.7,10.9,0,3,1.7,3,4.6,0,6.3"/>
    </g>
  </g>
  <path d="M566.1,601.4h-2v10.6c0,.4.2.7.5.9l1,.6c.3.2.7.2,1.1,0l.8-.5c.4-.2.7-.7.7-1.2v-10.4h-2.1Z"/>
  <path class="st77" d="M566.1,591.1c-5,0-7.9,10.2-7.9,10.3v.2s0,0,0,0c.2,1.4,1,2.6,2.3,3.2,3.5,1.8,7.7,1.8,11.2,0,1.3-.6,2.1-1.8,2.3-3.2,0,0,0,0,0,0h0c0-.2-3-10.5-7.9-10.5"/>
  <path class="st75" d="M571.6,604.8c1.3-.6,2.1-1.8,2.3-3.2,0,0,0,0,0,0h0c-.6-2.3-1.5-4.4-2.7-6.5-.7-.6-1.6-.9-2.5-.9-5,0-7.9,10.2-7.9,10.3v.2s0,0,0,0v.2c3.4,1.6,7.4,1.5,10.8-.2"/>
  <g class="st78">
    <g class="st12">
      <path class="st79" d="M577.3,615.2c-3.4,1.7-7.5,1.7-10.9,0-3-1.7-3-4.6,0-6.3,3.4-1.7,7.5-1.7,10.9,0,3,1.7,3,4.6,0,6.3"/>
    </g>
  </g>
  <path d="M522,585.4h-3v16c0,.6.3,1.1.8,1.3l1.5.8c.2.1.5.2.8.2.3,0,.6,0,.8-.2l1.1-.7c.6-.4,1-1.1,1-1.8v-15.7h-3Z"/>
  <path class="st77" d="M533.8,571.9c0,13.6-5.3,21.2-11.8,21.2s-11.8-7.8-11.8-21.2,5.3-21.2,11.8-21.2,11.8,7.6,11.8,21.2"/>
  <path class="st75" d="M533.8,571.9c0-7.4-1.6-13-4-16.5-.3,0-.6,0-.9,0-6.5,0-11.8,7.8-11.8,21.2s1.6,12.9,4.1,16.5c.3,0,.6,0,.9,0,6.5,0,11.8-7.6,11.8-21.2"/>
  <g class="st78">
    <g class="st9">
      <path class="st79" d="M538.5,606.3c-4.7,2.7-12.4,2.7-17.1,0s-4.7-7.2,0-9.9,12.4-2.7,17.1,0,4.7,7.2,0,9.9"/>
    </g>
  </g>
  <polygon class="st76" points="421.2 814.7 390.2 796.8 415 782.6 445.9 800.5 421.2 814.7"/>
  <g class="st50">
    <g>
      <path class="st76" d="M412.8,781.5c-3.1,3.1-7.6,5.2-11.5,7.1-4.7,2.3-9.1,5.4-13.8,7.7,1.8,1.1,3.4,2.3,5.2,3.4,1.3.5,2.5,1.1,3.6,1.9.6.4,1.1.8,1.5,1,.9.4,1.8.9,2.6,1.6l28.3-16.3c-3.2-1.4-6.3-3.1-9.3-4.5-1.9-.8-3.7-1.8-5.5-2.8-.3.4-.5.7-.8,1"/>
      <path class="st76" d="M406.9,807.7c4.9,2.8,9.9,5.3,14.5,8.5,1-.4,1.9-.9,2.8-1.4,6.1-3.7,12.2-7.2,18.3-10.8,2.1-1.2,4.1-2.4,6.1-3.5-7.2-3.5-13.9-7.7-20.1-12.7l-28.2,16.3c2.3,1.1,4.5,2.2,6.7,3.5"/>
    </g>
  </g>
  <path d="M406.1,782h-2v10.6c0,.4.2.7.5.9l1,.6c.2,0,.3.1.5.2.2,0,.4,0,.5-.2l.8-.5c.4-.2.7-.7.7-1.2v-10.4h-2.1Z"/>
  <path class="st77" d="M406.1,771.7c-5,0-7.9,10.2-7.9,10.3v.3c.2,1.4,1,2.6,2.3,3.2,3.5,1.8,7.7,1.8,11.2,0,1.3-.6,2.2-1.8,2.3-3.2h0c0-.3-3-10.6-7.9-10.6"/>
  <path class="st75" d="M411.6,785.4c1.3-.6,2.2-1.8,2.3-3.2h0c-.6-2.3-1.5-4.5-2.7-6.5-.7-.6-1.6-.9-2.5-.9-5,0-7.9,10.2-7.9,10.3v.5c3.4,1.6,7.4,1.5,10.8-.2"/>
  <g class="st78">
    <g class="st51">
      <path class="st79" d="M417.2,795.8c-3.4,1.7-7.5,1.7-10.9,0-3-1.7-3-4.6,0-6.3,3.4-1.7,7.5-1.7,10.9,0,3,1.7,3,4.6,0,6.3"/>
    </g>
  </g>
  <polygon class="st76" points="586.2 703.7 555.2 685.8 580 671.6 610.9 689.5 586.2 703.7"/>
  <g class="st52">
    <g>
      <path class="st76" d="M577.8,670.5c-3.1,3.1-7.7,5.2-11.5,7.1-4.7,2.3-9.1,5.4-13.8,7.7,1.8,1.1,3.4,2.3,5.2,3.4,1.3.5,2.5,1.1,3.6,1.9.6.4,1.1.8,1.5,1,.9.4,1.8.9,2.6,1.6l28.3-16.3c-3.2-1.4-6.3-3.1-9.3-4.5-1.9-.8-3.7-1.8-5.5-2.8-.3.4-.5.7-.8,1"/>
      <path class="st76" d="M571.9,696.7c4.9,2.8,9.8,5.3,14.5,8.5,1-.4,1.9-.9,2.8-1.4,6.1-3.7,12.2-7.2,18.3-10.8,2.1-1.2,4.1-2.4,6.1-3.5-7.2-3.5-13.9-7.7-20.1-12.7l-28.2,16.3c2.3,1.1,4.5,2.2,6.7,3.5"/>
    </g>
  </g>
  <path d="M571.1,671h-2v10.6c0,.4.2.7.5.9l1,.6c.2,0,.3.1.5.2.2,0,.4,0,.5-.2l.8-.5c.4-.2.7-.7.7-1.2v-10.4h-2.1Z"/>
  <path class="st77" d="M571.1,660.7c-5,0-7.9,10.2-7.9,10.3v.3c.2,1.4,1,2.6,2.3,3.2,3.5,1.8,7.7,1.8,11.2,0,1.3-.6,2.2-1.8,2.3-3.2h0c0-.3-3-10.6-7.9-10.6"/>
  <path class="st75" d="M576.6,674.4c1.3-.6,2.2-1.8,2.3-3.2h0c-.6-2.3-1.5-4.5-2.7-6.5-.7-.6-1.6-.9-2.5-.9-5,0-7.9,10.2-7.9,10.3v.5c3.4,1.6,7.4,1.5,10.8-.2"/>
  <g class="st78">
    <g class="st53">
      <path class="st79" d="M582.2,684.8c-3.4,1.7-7.5,1.7-10.9,0-3-1.7-3-4.6,0-6.3,3.4-1.7,7.5-1.7,10.9,0,3,1.7,3,4.6,0,6.3"/>
    </g>
  </g>
  <polygon class="st76" points="872.2 731.7 841.2 713.8 866 699.6 896.9 717.5 872.2 731.7"/>
  <g class="st54">
    <g>
      <path class="st76" d="M863.8,698.5c-3.1,3.1-7.7,5.2-11.5,7.1-4.7,2.3-9.1,5.4-13.8,7.7,1.8,1.1,3.4,2.3,5.2,3.4,1.3.5,2.5,1.1,3.6,1.9.6.4,1.1.8,1.5,1,.9.4,1.8.9,2.6,1.6l28.3-16.3c-3.2-1.4-6.3-3.1-9.3-4.5-1.9-.8-3.7-1.8-5.5-2.8-.3.4-.5.7-.8,1"/>
      <path class="st76" d="M857.9,724.7c4.9,2.8,9.8,5.3,14.5,8.5,1-.4,1.9-.9,2.8-1.4,6.1-3.7,12.2-7.2,18.3-10.8,2.1-1.2,4.1-2.4,6.1-3.5-7.2-3.5-13.9-7.7-20.1-12.7l-28.2,16.3c2.3,1.1,4.5,2.2,6.7,3.5"/>
    </g>
  </g>
  <path d="M857.1,699h-2v10.6c0,.4.2.7.5.9l1,.6c.2,0,.3.1.5.2.2,0,.4,0,.5-.2l.8-.5c.4-.2.7-.7.7-1.2v-10.4h-2.1Z"/>
  <path class="st77" d="M857.1,688.7c-5,0-7.9,10.2-7.9,10.3v.3c.2,1.4,1,2.6,2.3,3.2,3.5,1.8,7.7,1.8,11.2,0,1.3-.6,2.2-1.8,2.3-3.2h0c0-.3-3-10.6-7.9-10.6"/>
  <path class="st75" d="M862.6,702.4c1.3-.6,2.2-1.8,2.3-3.2h0c-.6-2.3-1.5-4.5-2.7-6.5-.7-.6-1.6-.9-2.5-.9-5,0-7.9,10.2-7.9,10.3v.5c3.4,1.6,7.4,1.5,10.8-.2"/>
  <g class="st78">
    <g class="st55">
      <path class="st79" d="M868.2,712.8c-3.4,1.7-7.5,1.7-10.9,0-3-1.7-3-4.6,0-6.3,3.4-1.7,7.5-1.7,10.9,0,3,1.7,3,4.6,0,6.3"/>
    </g>
  </g>
  <polygon class="st76" points="1006.2 731.7 975.2 713.8 1000 699.6 1030.9 717.5 1006.2 731.7"/>
  <g class="st48">
    <g>
      <path class="st76" d="M997.8,698.5c-3.1,3.1-7.7,5.2-11.5,7.1-4.7,2.3-9.1,5.4-13.8,7.7,1.8,1.1,3.4,2.3,5.2,3.4,1.3.5,2.5,1.1,3.6,1.9.6.4,1.1.8,1.5,1,.9.4,1.8.9,2.6,1.6l28.3-16.3c-3.2-1.4-6.3-3.1-9.3-4.5-1.9-.8-3.7-1.8-5.5-2.8-.3.4-.5.7-.8,1"/>
      <path class="st76" d="M991.9,724.7c4.9,2.8,9.8,5.3,14.5,8.5,1-.4,1.9-.9,2.8-1.4,6.1-3.7,12.2-7.2,18.3-10.8,2.1-1.2,4.1-2.4,6.1-3.5-7.2-3.5-13.9-7.7-20.1-12.7l-28.2,16.3c2.3,1.1,4.5,2.2,6.7,3.5"/>
    </g>
  </g>
  <path d="M991.1,699h-2v10.6c0,.4.2.7.5.9l1,.6c.2,0,.3.1.5.2.2,0,.4,0,.5-.2l.8-.5c.4-.2.7-.7.7-1.2v-10.4h-2.1Z"/>
  <path class="st77" d="M991.1,688.7c-5,0-7.9,10.2-7.9,10.3v.3c.2,1.4,1,2.6,2.3,3.2,3.5,1.8,7.7,1.8,11.2,0,1.3-.6,2.2-1.8,2.3-3.2h0c0-.3-3-10.6-7.9-10.6"/>
  <path class="st75" d="M996.6,702.4c1.3-.6,2.2-1.8,2.3-3.2h0c-.6-2.3-1.5-4.5-2.7-6.5-.7-.6-1.6-.9-2.5-.9-5,0-7.9,10.2-7.9,10.3v.5c3.4,1.6,7.4,1.5,10.8-.2"/>
  <g class="st78">
    <g class="st46">
      <path class="st79" d="M1002.2,712.8c-3.4,1.7-7.5,1.7-10.9,0-3-1.7-3-4.6,0-6.3,3.4-1.7,7.5-1.7,10.9,0,3,1.7,3,4.6,0,6.3"/>
    </g>
  </g>
  <polygon class="st76" points="1240.2 731.7 1209.2 713.8 1233.9 699.6 1264.9 717.5 1240.2 731.7"/>
  <g class="st49">
    <g>
      <path class="st76" d="M1231.8,698.5c-3.1,3.1-7.7,5.2-11.6,7.1-4.7,2.3-9.1,5.4-13.8,7.7,1.8,1.1,3.4,2.3,5.2,3.4,1.3.5,2.5,1.1,3.6,1.9.6.4,1.1.8,1.5,1,.9.4,1.8.9,2.6,1.6l28.3-16.3c-3.2-1.4-6.3-3.1-9.3-4.5-1.9-.9-3.7-1.8-5.5-2.9-.3.4-.5.7-.8,1"/>
      <path class="st76" d="M1225.9,724.7c4.9,2.8,9.8,5.3,14.5,8.5,1-.4,1.9-.9,2.8-1.4,6.1-3.7,12.2-7.2,18.3-10.8,2.1-1.2,4.1-2.4,6.1-3.5-7.2-3.5-13.9-7.7-20.1-12.7l-28.2,16.3c2.3,1.1,4.5,2.2,6.7,3.5"/>
    </g>
  </g>
  <path d="M1225.1,699h-2v10.6c0,.4.2.7.5.9l1,.6c.2,0,.3.1.5.2.2,0,.4,0,.5-.2l.8-.5c.4-.2.7-.7.7-1.2v-10.4h-2.1Z"/>
  <path class="st77" d="M1225.1,688.7c-5,0-7.9,10.2-7.9,10.3,0,0,0,0,0,.1v.2c.2,1.4,1,2.6,2.3,3.2,3.5,1.8,7.7,1.8,11.2,0,1.3-.6,2.2-1.8,2.3-3.2h0c0-.3-3-10.6-7.9-10.6"/>
  <path class="st75" d="M1230.6,702.4c1.3-.6,2.2-1.8,2.3-3.2h0c-.6-2.3-1.5-4.5-2.7-6.5-.7-.6-1.6-.9-2.5-.9-5,0-7.9,10.2-7.9,10.3v.5c3.4,1.6,7.4,1.5,10.8-.2"/>
  <g class="st78">
    <g class="st47">
      <path class="st79" d="M1236.2,712.8c-3.4,1.7-7.5,1.7-10.9,0-3-1.7-3-4.6,0-6.3,3.4-1.7,7.5-1.7,10.9,0,3,1.7,3,4.6,0,6.3"/>
    </g>
  </g>
  <polygon class="st76" points="949.2 658.7 918.2 640.8 943 626.6 973.9 644.5 949.2 658.7"/>
  <g class="st42">
    <g>
      <path class="st76" d="M940.8,625.5c-3.1,3.1-7.7,5.2-11.5,7.1-4.7,2.3-9.1,5.4-13.8,7.7,1.8,1.1,3.4,2.3,5.2,3.4,1.3.5,2.5,1.1,3.6,1.9.6.4,1.1.8,1.5,1,.9.4,1.8.9,2.6,1.6l28.3-16.3c-3.2-1.4-6.3-3.1-9.3-4.5-1.9-.8-3.7-1.8-5.5-2.8-.3.4-.5.7-.8,1"/>
      <path class="st76" d="M934.9,651.7c4.9,2.8,9.8,5.3,14.5,8.5,1-.4,1.9-.9,2.8-1.4,6.1-3.7,12.2-7.2,18.3-10.8,2.1-1.2,4.1-2.4,6.1-3.5-7.2-3.5-13.9-7.7-20.1-12.7l-28.2,16.3c2.3,1.1,4.5,2.2,6.7,3.5"/>
    </g>
  </g>
  <path d="M934.1,626h-2v10.6c0,.4.2.7.5.9l1,.6c.2,0,.3.1.5.2.2,0,.4,0,.5-.2l.8-.5c.4-.2.7-.7.7-1.2v-10.4h-2.1Z"/>
  <path class="st77" d="M934.1,615.7c-5,0-7.9,10.2-7.9,10.3v.3c.2,1.4,1,2.6,2.3,3.2,3.5,1.8,7.7,1.8,11.2,0,1.3-.6,2.2-1.8,2.3-3.2h0c0-.3-3-10.6-7.9-10.6"/>
  <path class="st75" d="M939.6,629.4c1.3-.6,2.2-1.8,2.3-3.2h0c-.6-2.3-1.5-4.5-2.7-6.5-.7-.6-1.6-.9-2.5-.9-5,0-7.9,10.2-7.9,10.3v.5c3.4,1.6,7.4,1.5,10.8-.2"/>
  <g class="st78">
    <g class="st36">
      <path class="st79" d="M945.2,639.8c-3.4,1.7-7.5,1.7-10.9,0-3-1.7-3-4.6,0-6.3,3.4-1.7,7.5-1.7,10.9,0,3,1.7,3,4.6,0,6.3"/>
    </g>
  </g>
  <path class="st2" d="M11.7,1115.5l734.4-427.8h0l31.7-18.3,93.3-53.8,31.7-18.3h0c8.4-4.8,22-5,30.6-.3l.5.3c27.8,16.1,72.9,16,100.7,0h0c8.6-5,22.6-5,31.2,0l.5.3h0l83.9,48.4,7.5,4.3,26.1,15h0c27.8,16.1,70.1,21,100.8,0,.2-.1.3-.2.5-.3h0l17.6-10.2,24.6-13.5,47.2-27.2h0l6.2-3.6,2.1-1.2h0l122.8-71.2h0l.5-.3c8.8-5.1,23.1-5.1,31.9,0h0l34,19.5c28.5,16.1,74.2,16,102.5-.3h0l33.9-19.5h.2c0-.1,40.7-23.7,40.7-23.7h0l41-23.7c27.5-20.6,7.8-36.9,7.8-36.9l-32.7-18.9-244.4-141.1c-8.1-5-8.2-12.7-.2-17.8l274.3-158.4h0c27.9-16.4,28-42.6.2-59h0l-.5-.3c-8.7-5-8.8-13.1-.3-18.2h0l32.8-19h0L1791.6,0l-32.5,18.8h0l-.3.2h0c-28.2,16.5-28.1,43,.3,59.4.2,0,.5.2.5.3,8.2,5.1,8.1,13.1-.6,18.1h0l-40,23.1-191.9,110.8-41.9,24.2h0c-28,16.5-27.8,42.9.6,59.3h0l227.9,131.6,41.1,23.7.3-.2-41.3,23.8h0l-40.8,23.6h-.2c0,.1-34.8,20.2-34.8,20.2-8.5,4.4-21.4,4.3-29.9,0l-26.4-15.3-7.8-4.5h0c-28.5-16.4-74.7-16.4-103.2,0l-.5.3h0l-124.1,72.1-53.4,30.8-17.3,10.4-24.9,14.4h0l-.5.3c-8.6,5-22.5,5-31.1,0l-117.5-67.8-.5-.3c-27.8-16.1-72.9-16.1-100.8,0h0c-8.6,5-22.5,5-31.1,0l-.5-.3h0s-41.2-35.6-99.7,0l-32.2,18.6h0l-121,69.8-4.5,2.5h0L0,1081.8"/>
  <polygon class="st2" points="778.4 698.6 660 630.2 778.4 561.9 896.8 630.2 778.4 698.6"/>
  <g class="st37">
    <g>
      <rect class="st2" x="886.7" y="516.6" width="114.3" height="114.3"/>
      <rect class="st2" x="886.7" y="630.9" width="114.3" height="114.3"/>
      <rect class="st2" x="772.5" y="516.6" width="114.3" height="114.3"/>
      <rect class="st2" x="772.5" y="630.9" width="114.3" height="114.3"/>
      <rect class="st2" x="658.2" y="516.6" width="114.3" height="114.3"/>
      <rect class="st2" x="658.2" y="630.9" width="114.3" height="114.3"/>
    </g>
  </g>
  <polygon class="st76" points="854.3 462.3 823.4 444.4 848.1 430.2 879 448.1 854.3 462.3"/>
  <g class="st38">
    <g>
      <path class="st76" d="M846,429.1c-3.1,3.1-7.6,5.2-11.5,7.1-4.7,2.3-9.1,5.4-13.8,7.7,1.8,1.1,3.4,2.3,5.2,3.4,1.3.5,2.5,1.1,3.6,1.9l1.5,1c.9.4,1.8.9,2.6,1.6l28.3-16.3c-3.2-1.4-6.3-3.1-9.3-4.5-1.9-.8-3.7-1.8-5.5-2.9-.3.4-.5.7-.8,1"/>
      <path class="st76" d="M840,455.3c4.9,2.8,9.8,5.3,14.5,8.5,1-.4,1.9-.8,2.8-1.4,6.1-3.7,12.2-7.3,18.3-10.8,2.1-1.2,4.1-2.5,6.1-3.5-7.2-3.5-13.9-7.7-20.2-12.7l-28.2,16.3c2.3,1.1,4.5,2.2,6.7,3.5"/>
    </g>
  </g>
  <path d="M839.2,429.6h-2v10.6c0,.4.2.7.5.9l1,.6c.3.2.7.2,1.1,0l.8-.5c.4-.2.7-.7.7-1.2v-10.4h-2.1Z"/>
  <path class="st77" d="M839.2,419.3c-5,0-7.9,10.2-7.9,10.3v.3c.2,1.4,1,2.6,2.3,3.2,3.5,1.8,7.7,1.8,11.2,0,1.3-.6,2.2-1.8,2.3-3.2h0c0-.3-2.9-10.6-7.9-10.6"/>
  <path class="st75" d="M844.7,433c1.3-.6,2.2-1.8,2.3-3.2h0c-.6-2.3-1.5-4.5-2.7-6.5-.7-.6-1.6-.9-2.5-.9-5,0-7.9,10.2-7.9,10.3,0,0,0,0,0,.1v.4c3.4,1.6,7.4,1.5,10.8-.2"/>
  <g class="st78">
    <g class="st39">
      <path class="st79" d="M850.4,443.4c-3.4,1.7-7.5,1.7-10.9,0-3-1.7-3-4.6,0-6.3,3.4-1.7,7.5-1.7,10.9,0,3,1.7,3,4.6,0,6.3"/>
    </g>
  </g>
  <polygon class="st76" points="1477.3 608.3 1446.4 590.4 1471.1 576.2 1502.1 594.1 1477.3 608.3"/>
  <g class="st40">
    <g>
      <path class="st76" d="M1469,575.1c-3.1,3.1-7.6,5.2-11.6,7.1-4.7,2.3-9.1,5.3-13.8,7.7,1.8,1.1,3.4,2.3,5.2,3.4,1.3.5,2.5,1.1,3.6,1.9l1.5,1c.9.4,1.8.9,2.6,1.6l28.3-16.3c-3.2-1.4-6.3-3.1-9.3-4.5-1.9-.8-3.7-1.8-5.5-2.9-.3.4-.5.7-.8,1"/>
      <path class="st76" d="M1463,601.3c4.9,2.8,9.8,5.3,14.5,8.5,1-.4,1.9-.8,2.8-1.4,6.1-3.7,12.2-7.3,18.3-10.8,2.1-1.2,4.1-2.5,6.1-3.5-7.2-3.5-13.9-7.7-20.2-12.7l-28.2,16.3c2.3,1.1,4.5,2.2,6.7,3.5"/>
    </g>
  </g>
  <path d="M1462.2,575.6h-2v10.6c0,.4.2.7.5.9l1,.6c.3.2.7.2,1.1,0l.8-.5c.4-.2.7-.7.7-1.2v-10.4h-2.1Z"/>
  <path class="st77" d="M1462.2,565.3c-5,0-7.9,10.2-7.9,10.3v.3c.2,1.4,1,2.6,2.3,3.2,3.5,1.8,7.7,1.8,11.2,0,1.3-.6,2.2-1.8,2.3-3.2h0c0-.3-2.9-10.6-7.9-10.6"/>
  <path class="st75" d="M1467.7,579c1.3-.6,2.2-1.8,2.3-3.2h0c-.6-2.3-1.5-4.5-2.7-6.5-.7-.6-1.6-.9-2.5-.9-5,0-7.9,10.2-7.9,10.3v.5c3.4,1.6,7.4,1.5,10.8-.2"/>
  <g class="st78">
    <g class="st43">
      <path class="st79" d="M1473.4,589.4c-3.4,1.7-7.5,1.7-10.9,0-3-1.7-3-4.6,0-6.3,3.4-1.7,7.5-1.7,10.9,0,3,1.7,3,4.6,0,6.3"/>
    </g>
  </g>
  <polygon class="st76" points="1112.5 712.8 1170.5 679.3 1071.8 622.3 1013.8 655.8 1112.5 712.8"/>
  <g class="st44">
    <g>
      <path class="st76" d="M1013.5,657.1l.6.3c1.3.6,2.5,1.4,3.6,2.2,1.2.8,2.3,1.7,3.3,2.8,3.2,1.2,6.2,2.7,9.1,4.5v-22.2c-3.1,2.6-6.4,4.8-10,6.6-2.3,1.1-5.1,2-7.1,3.7,0,.4-.2.9-.3,1.5,0,0,0,0,0,.1h0c.2.1.5.3.7.5"/>
      <path class="st76" d="M1080.5,626.8c-3.1-1.9-6.6-3.8-9.9-5.9-.8.6-1.7,1.2-2.5,1.7-.4.3-.8.7-1.3,1-.9.6-1.9,1.1-2.7,1.7-.3.2-.6.4-.9.5-3,1.9-5.9,3.8-8.9,5.6-3.9,2.4-8.2,3.9-12.2,5.9-.6.5-1.2.9-1.9,1.2h55.4v-3.2c-.3-.1-.6-.3-.9-.5-4.7-2.9-9.6-5.2-14.3-8.1"/>
      <path class="st76" d="M1032.9,668.3c.2.2,2.8,2,3.3,2.6,10,4.1,18.8,10.5,28.5,15.4,5.4,2.7,10.5,5.9,15.8,8.8,4.7,2.5,9.7,5,13.3,8.9h1.9v-65.5h-54.3c-2.1,1.7-4.4,3-6.9,4-.5.2-2.5,1.2-1.4.6-.6.3-1.2.6-1.7.9l-1.1.6v21.4c1,.6,1.9,1.4,2.7,2.3"/>
      <path class="st76" d="M1158.8,672.2c-.7-.4-1.5-.8-2.2-1.2-.7-.4-1.4-.9-2-1.5-11.8-6.6-22.9-14.8-35-20.7-.9-.4-1.7-1-2.4-1.7-.9-.3-1.7-.7-2.5-1.2-.2,0-.4,0-.5,0-1.7-.6-3.4-1.4-4.9-2.3-2.2-1.2-4.3-2.7-6.1-4.5-.1-.1-.2-.3-.4-.4h-7.2v65.5h34.7c2.1-2,4.6-3.7,7.3-4.9,2.6-1.3,4.8-3.2,7.3-4.6,4.8-2.6,9.8-5,14.6-7.7.5-.5,1-1,1.6-1.4v-12.1c-.8-.3-1.6-.7-2.3-1.1"/>
      <path class="st76" d="M1117.3,711.5c3.6-2.2,7.1-4.6,10.4-7.1.2-.1.4-.2.6-.3h-32.3c.2.1.4.2.6.4h.3c1.2.5,2.3,1,3.3,1.6,1.3.7,2.9,1.7,4.2,2.5.7.5,4.2,2.4,5.7,4,.4.1.8.2,1.3.4l.5.3c.7-.1,1.3-.3,1.9-.6.7-.4,5.1-2.3,3.4-1.2"/>
      <path class="st76" d="M1162.5,684.5c2.5-1.7,5.3-3.1,8.1-4.1.1-.4.3-.8.5-1.2,0-.1.1-.3.2-.4-1.5-.8-3.2-1.2-4.6-2-2.1-1.3-3.9-2.9-5.6-4.7v13.6c.5-.4.9-.7,1.4-1.1"/>
    </g>
  </g>
  <path d="M1097.1,642.7h-3v16c0,.5.3,1.1.8,1.3l1.5.8c.5.3,1.1.3,1.6,0l1.2-.7c.6-.4,1-1.1,1-1.8v-15.7h-3Z"/>
  <path class="st77" d="M1108.9,629.1c0,13.6-5.3,21.2-11.8,21.2s-11.8-7.8-11.8-21.2,5.3-21.1,11.8-21.1,11.8,7.6,11.8,21.2"/>
  <path class="st75" d="M1108.9,629.1c0-7.4-1.6-13-4-16.5-.3,0-.6,0-.9,0-6.5,0-11.8,7.8-11.8,21.2s1.6,12.9,4.1,16.5c.3,0,.6,0,.9,0,6.5,0,11.8-7.6,11.8-21.2"/>
  <g class="st78">
    <g class="st45">
      <path class="st79" d="M1113.7,663.5c-4.7,2.7-12.4,2.7-17.1,0s-4.7-7.2,0-9.9,12.4-2.7,17.1,0,4.7,7.2,0,9.9"/>
    </g>
  </g>
  <path d="M1115,667.7h-2v10.6c0,.4.2.7.5.9l1,.6c.2,0,.3.1.5.2.2,0,.4,0,.5-.2l.8-.5c.4-.2.7-.7.7-1.2v-10.4h-2.1Z"/>
  <path class="st77" d="M1115,657.3c-5,0-7.9,10.2-7.9,10.3v.3c.2,1.4,1,2.6,2.3,3.2,3.5,1.8,7.7,1.8,11.2,0,1.3-.6,2.2-1.8,2.3-3.2h0c0-.3-2.9-10.6-7.9-10.6"/>
  <path class="st75" d="M1120.4,671.1c1.3-.6,2.2-1.8,2.3-3.2h0c-.6-2.3-1.5-4.5-2.7-6.5-.7-.6-1.6-.9-2.5-.9-5,0-7.9,10.2-7.9,10.3v.5c3.4,1.6,7.4,1.5,10.8-.2"/>
  <g class="st78">
    <g class="st41">
      <path class="st79" d="M1126.1,681.5c-3.4,1.8-7.5,1.8-10.9,0-3-1.7-3-4.6,0-6.3,3.4-1.7,7.5-1.7,10.9,0,3,1.7,3,4.6,0,6.3"/>
    </g>
  </g>
  <path d="M1045.4,624.5v31.6c0,.3.1.5.4.7l.8.4c.1,0,.3.1.4.1.1,0,.3,0,.4-.1l.6-.4c.3-.2.5-.5.5-.9v-31.4h-3.1Z"/>
  <path class="st77" d="M1047,593.9c-7.5,0-11.9,36.6-12,36.8v.5c0,1.7,1.2,3.4,3.5,4.8,4.7,2.7,12.2,2.7,16.9,0,2.3-1.3,3.4-3,3.5-4.8h0c0-.5-4.4-37.3-12-37.3"/>
  <path class="st75" d="M1055.4,636c2.3-1.3,3.4-3,3.5-4.8h0c0-.4-2.6-21.7-7.1-31.9h0c-7.5,0-11.9,36.6-12,36.8v.3s0,0,0,.1h0c4.7,2,11.4,1.8,15.6-.6"/>
  <g class="st78">
    <g class="st62">
      <path class="st79" d="M1073.9,651c-4.7-2.7-12.4-2.7-17.1,0-1.6.8-2.8,2.2-3.4,3.9h-6.8v2.2h6.8c.6,1.6,1.8,3,3.4,3.8,4.7,2.7,12.4,2.7,17.1,0s4.7-7.2,0-9.9"/>
    </g>
  </g>
  <polygon class="st76" points="1189.5 607.8 1247.5 574.3 1148.8 517.3 1090.8 550.8 1189.5 607.8"/>
  <g class="st56">
    <g>
      <path class="st76" d="M1090.5,552.1l.6.3c1.3.6,2.5,1.4,3.6,2.2,1.2.8,2.3,1.7,3.3,2.8,3.2,1.2,6.2,2.7,9.1,4.5v-22.2c-3.1,2.6-6.4,4.8-10,6.6-2.3,1.1-5.1,2-7.1,3.7,0,.4-.2.9-.3,1.5h0c0,.1,0,.1,0,.1.2.1.5.3.7.5"/>
      <path class="st76" d="M1157.5,521.8c-3.1-1.9-6.6-3.8-9.9-5.9-.8.6-1.7,1.2-2.5,1.7-.4.3-.8.7-1.3,1-.9.6-1.9,1.1-2.7,1.7-.3.2-.6.4-.9.5-3,1.9-5.9,3.8-8.9,5.6-3.9,2.4-8.2,3.9-12.2,5.9-.6.5-1.2.9-1.9,1.2h55.4v-3.2c-.3-.1-.6-.3-.9-.5-4.7-2.9-9.6-5.2-14.3-8.1"/>
      <path class="st76" d="M1109.9,563.3c.2.2,2.8,2,3.3,2.6,10,4.1,18.8,10.5,28.5,15.4,5.4,2.7,10.5,5.9,15.8,8.8,4.7,2.5,9.7,5,13.3,8.9h1.9v-65.5h-54.3c-2.1,1.7-4.4,3-6.9,4-.5.2-2.5,1.2-1.4.6-.6.3-1.2.6-1.7.9l-1.1.6v21.4c1,.6,1.9,1.4,2.7,2.3"/>
      <path class="st76" d="M1235.8,567.2c-.7-.4-1.5-.8-2.2-1.2-.7-.4-1.4-.9-2-1.5-11.8-6.6-22.9-14.8-35-20.7-.9-.4-1.7-1-2.4-1.7-.9-.3-1.7-.7-2.5-1.2-.2,0-.4,0-.5,0-1.7-.6-3.4-1.4-4.9-2.3-2.2-1.2-4.3-2.7-6.1-4.5-.1-.1-.2-.3-.4-.4h-7.2v65.5h34.7c2.1-2,4.6-3.7,7.3-4.9,2.6-1.3,4.8-3.2,7.3-4.6,4.8-2.6,9.8-5,14.6-7.7.5-.5,1-1,1.6-1.4v-12.1c-.8-.3-1.6-.7-2.3-1.1"/>
      <path class="st76" d="M1194.3,606.5c3.6-2.2,7.1-4.6,10.4-7.1.2-.1.4-.2.6-.3h-32.3c.2.1.4.2.6.4h.3c1.2.5,2.3,1,3.3,1.6,1.3.7,2.9,1.7,4.2,2.5.7.5,4.2,2.4,5.7,4,.4.1.8.2,1.3.4l.5.3c.7-.1,1.3-.3,1.9-.6.7-.4,5.1-2.3,3.4-1.2"/>
      <path class="st76" d="M1239.5,579.5c2.5-1.7,5.3-3.1,8.1-4.1.1-.4.3-.8.5-1.2,0-.1.1-.3.2-.4-1.5-.8-3.2-1.2-4.6-2-2.1-1.3-3.9-2.9-5.6-4.7v13.6c.5-.4.9-.7,1.4-1.1"/>
    </g>
  </g>
  <path d="M1174.1,537.7h-3v16c0,.5.3,1.1.8,1.3l1.5.8c.5.3,1.1.3,1.6,0l1.2-.7c.6-.4,1-1.1,1-1.8v-15.7h-3Z"/>
  <path class="st77" d="M1185.9,524.1c0,13.6-5.3,21.2-11.8,21.2s-11.8-7.8-11.8-21.2,5.3-21.1,11.8-21.1,11.8,7.6,11.8,21.2"/>
  <path class="st75" d="M1185.9,524.1c0-7.4-1.6-13-4-16.5-.3,0-.6,0-.9,0-6.5,0-11.8,7.8-11.8,21.2s1.6,12.9,4.1,16.5h.9c6.5,0,11.8-7.6,11.8-21.2"/>
  <g class="st78">
    <g class="st57">
      <path class="st79" d="M1190.7,558.5c-4.7,2.7-12.4,2.7-17.1,0s-4.7-7.2,0-9.9,12.4-2.7,17.1,0,4.7,7.2,0,9.9"/>
    </g>
  </g>
  <path d="M1192,562.7h-2v10.6c0,.4.2.7.5.9l1,.6c.2,0,.3.1.5.2.2,0,.4,0,.5-.2l.8-.5c.4-.2.7-.7.7-1.2v-10.4h-2.1Z"/>
  <path class="st77" d="M1192,552.3c-5,0-7.9,10.2-7.9,10.3v.3c.2,1.4,1,2.6,2.3,3.2,3.5,1.8,7.7,1.8,11.2,0,1.3-.6,2.2-1.8,2.3-3.2h0c0-.3-2.9-10.6-7.9-10.6"/>
  <path class="st75" d="M1197.4,566.1c1.3-.6,2.2-1.8,2.3-3.2h0c-.6-2.3-1.5-4.5-2.7-6.5-.7-.6-1.6-.9-2.5-.9-5,0-7.9,10.2-7.9,10.3v.5c3.4,1.6,7.4,1.5,10.8-.2"/>
  <g class="st78">
    <g class="st58">
      <path class="st79" d="M1203.1,576.5c-3.4,1.8-7.5,1.8-10.9,0-3-1.7-3-4.6,0-6.3,3.4-1.7,7.5-1.7,10.9,0,3,1.7,3,4.6,0,6.3"/>
    </g>
  </g>
  <path d="M1122.4,519.5v31.6c0,.3.1.5.4.7l.8.4c.1,0,.3.1.4.1.1,0,.3,0,.4-.1l.6-.4c.3-.2.5-.5.5-.9v-31.4h-3.1Z"/>
  <path class="st77" d="M1124,488.9c-7.5,0-11.9,36.6-12,36.8v.2s0,.1,0,.2h0c0,1.8,1.2,3.6,3.5,4.9,4.7,2.7,12.2,2.7,16.9,0,2.3-1.3,3.4-3,3.5-4.8h0c0-.5-4.4-37.3-12-37.3"/>
  <path class="st75" d="M1132.4,531c2.3-1.3,3.4-3,3.5-4.8h0c0-.4-2.6-21.7-7.1-31.9h0c-7.5,0-11.9,36.6-12,36.8v.3s0,0,0,.1h0c4.7,2,11.4,1.8,15.6-.6"/>
  <g class="st78">
    <g class="st59">
      <path class="st79" d="M1150.9,546c-4.7-2.7-12.4-2.7-17.1,0-1.6.8-2.8,2.2-3.4,3.9h-6.8v2.2h6.8c.6,1.6,1.8,3,3.4,3.8,4.7,2.7,12.4,2.7,17.1,0s4.7-7.2,0-9.9"/>
    </g>
  </g>
  <polygon class="st76" points="1651.5 686.8 1709.5 653.3 1610.8 596.3 1552.8 629.8 1651.5 686.8"/>
  <g class="st60">
    <g>
      <path class="st76" d="M1552.5,631.1l.6.3c1.3.6,2.5,1.4,3.6,2.2,1.2.8,2.3,1.7,3.3,2.8,3.2,1.2,6.2,2.7,9.1,4.5v-22.2c-3.1,2.6-6.4,4.8-10,6.6-2.3,1.1-5.1,2-7.1,3.7,0,.4-.2.9-.3,1.5h0c0,.1,0,.1,0,.1.2.1.5.3.7.5"/>
      <path class="st76" d="M1619.5,600.8c-3.1-1.9-6.6-3.8-9.9-5.9-.8.6-1.7,1.2-2.5,1.7-.4.3-.8.7-1.3,1-.9.6-1.9,1.1-2.7,1.7-.3.2-.6.4-.9.5-3,1.9-5.9,3.8-8.9,5.6-3.9,2.4-8.2,3.9-12.2,5.9-.6.5-1.2.9-1.9,1.2h55.4v-3.2c-.3-.1-.6-.3-.9-.5-4.7-2.9-9.6-5.2-14.3-8.1"/>
      <path class="st76" d="M1571.9,642.3c.2.2,2.8,2,3.3,2.6,10,4.1,18.8,10.5,28.5,15.4,5.4,2.7,10.5,5.9,15.8,8.8,4.7,2.5,9.7,5,13.3,8.9h1.9v-65.5h-54.3c-2.1,1.7-4.4,3-6.9,4-.5.2-2.5,1.2-1.4.6-.6.3-1.2.6-1.7.9l-1.1.6v21.4c1,.6,1.9,1.4,2.7,2.3"/>
    </g>
  </g>
  <path class="st77" d="M1647.9,603.1c0,13.6-5.3,21.2-11.8,21.2s-11.8-7.8-11.8-21.2,5.3-21.1,11.8-21.1,11.8,7.6,11.8,21.2"/>
  <path class="st75" d="M1647.9,603.1c0-7.4-1.6-13-4-16.5-.3,0-.6,0-.9,0-6.5,0-11.8,7.8-11.8,21.2s1.6,12.9,4.1,16.5h.9c6.5,0,11.8-7.6,11.8-21.2"/>
  <g class="st78">
    <g class="st63">
      <path class="st79" d="M1652.7,637.5c-4.7,2.7-12.4,2.7-17.1,0s-4.7-7.2,0-9.9,12.4-2.7,17.1,0,4.7,7.2,0,9.9"/>
    </g>
  </g>
  <path d="M1584.4,598.5v31.6c0,.3.1.5.4.7l.8.4c.1,0,.3.1.4.1.1,0,.3,0,.4-.1l.6-.4c.3-.2.5-.5.5-.9v-31.4h-3.1Z"/>
  <path class="st77" d="M1586,567.9c-7.5,0-11.9,36.6-12,36.8v.2s0,.1,0,.2h0c0,1.8,1.2,3.6,3.5,4.9,4.7,2.7,12.2,2.7,16.9,0,2.3-1.3,3.4-3,3.5-4.8h0c0-.5-4.4-37.3-12-37.3"/>
  <path class="st75" d="M1594.4,610c2.3-1.3,3.4-3,3.5-4.8h0c0-.4-2.6-21.7-7.1-31.9h0c-7.5,0-11.9,36.6-12,36.8v.3s0,0,0,.1h0c4.7,2,11.4,1.8,15.6-.6"/>
  <g class="st78">
    <g class="st64">
      <path class="st79" d="M1612.9,625c-4.7-2.7-12.4-2.7-17.1,0-1.6.8-2.8,2.2-3.4,3.9h-6.8v2.2h6.8c.6,1.6,1.8,3,3.4,3.8,4.7,2.7,12.4,2.7,17.1,0s4.7-7.2,0-9.9"/>
    </g>
  </g>
  <polygon class="st76" points="1374.5 531.8 1432.5 498.3 1333.8 441.3 1275.8 474.8 1374.5 531.8"/>
  <g class="st65">
    <g>
      <path class="st76" d="M1275.5,476.1l.6.3c1.3.6,2.5,1.4,3.6,2.2,1.2.8,2.3,1.7,3.3,2.8,3.2,1.2,6.2,2.7,9.1,4.5v-22.2c-3.1,2.6-6.4,4.8-10,6.6-2.3,1.1-5.1,2-7.1,3.6,0,.4-.2.9-.3,1.5h0c0,.1,0,.1,0,.1.2.1.5.3.7.5"/>
      <path class="st76" d="M1342.5,445.7c-3.1-1.9-6.6-3.8-9.9-5.9-.8.6-1.7,1.1-2.5,1.7-.4.3-.8.7-1.3,1-.9.6-1.9,1.1-2.7,1.7-.3.2-.6.4-.9.5-3,1.9-5.9,3.8-8.9,5.6-3.9,2.4-8.2,3.9-12.2,5.9-.6.5-1.2.9-1.9,1.2h55.4v-3.2c-.3-.1-.6-.3-.9-.5-4.7-2.9-9.6-5.2-14.3-8.1"/>
      <path class="st76" d="M1294.9,487.3c.2.2,2.8,2,3.3,2.6,10,4.1,18.8,10.5,28.5,15.4,5.4,2.7,10.5,5.9,15.8,8.8,4.7,2.5,9.7,5,13.3,8.9h1.9v-65.5h-54.3c-2.1,1.7-4.4,3-6.9,4-.5.2-2.5,1.2-1.4.6-.6.3-1.2.6-1.7.9l-1.1.6v21.4c1,.6,1.9,1.4,2.7,2.3"/>
      <path class="st76" d="M1420.8,491.2c-.7-.4-1.5-.8-2.2-1.2-.7-.4-1.4-.9-2-1.5-11.8-6.6-22.9-14.8-35-20.7-.9-.4-1.7-1-2.4-1.7-.9-.3-1.7-.7-2.5-1.2-.2,0-.4,0-.5,0-1.7-.6-3.4-1.4-4.9-2.4-2.2-1.2-4.3-2.7-6.1-4.5-.1-.1-.2-.3-.4-.4h-7.2v65.5h34.7c2.1-2,4.6-3.7,7.3-4.9,2.6-1.3,4.8-3.2,7.3-4.6,4.8-2.6,9.8-5,14.6-7.7.5-.5,1-1,1.6-1.4v-12.1c-.8-.3-1.6-.7-2.3-1.1"/>
      <path class="st76" d="M1379.3,530.5c3.6-2.2,7.1-4.6,10.4-7.1.2-.1.4-.2.6-.3h-32.3c.2.1.4.2.6.4h.3c1.2.5,2.3,1,3.3,1.6,1.3.7,2.9,1.7,4.2,2.5.7.5,4.2,2.4,5.7,4,.4.1.8.2,1.3.4l.5.3c.7-.1,1.3-.3,1.9-.6.7-.4,5.1-2.3,3.4-1.2"/>
      <path class="st76" d="M1424.5,503.5c2.5-1.7,5.3-3.1,8.1-4.1.1-.4.3-.8.5-1.2,0-.1.1-.3.2-.4-1.5-.8-3.2-1.2-4.6-2-2.1-1.3-3.9-2.9-5.6-4.7v13.6c.5-.4.9-.7,1.4-1.1"/>
    </g>
  </g>
  <path d="M1359.1,461.7h-3v16c0,.5.3,1.1.8,1.3l1.5.9c.5.3,1.1.3,1.6,0l1.2-.7c.6-.4,1-1.1,1-1.8v-15.7h-3Z"/>
  <path class="st77" d="M1370.9,448.1c0,13.6-5.3,21.2-11.8,21.2s-11.8-7.8-11.8-21.2,5.3-21.1,11.8-21.1,11.8,7.6,11.8,21.2"/>
  <path class="st75" d="M1370.9,448.1c0-7.4-1.6-13-4-16.5-.3,0-.6,0-.9,0-6.5,0-11.8,7.8-11.8,21.2s1.6,12.9,4.1,16.5h.9c6.5,0,11.8-7.6,11.8-21.2"/>
  <g class="st78">
    <g class="st61">
      <path class="st79" d="M1375.7,482.5c-4.7,2.7-12.4,2.7-17.1,0s-4.7-7.2,0-9.9,12.4-2.7,17.1,0,4.7,7.2,0,9.9"/>
    </g>
  </g>
  <path d="M1377,486.7h-2v10.6c0,.4.2.7.5.9l1,.6c.2,0,.3.1.5.1.2,0,.4,0,.5-.2l.8-.5c.4-.2.7-.7.7-1.2v-10.4h-2.1Z"/>
  <path class="st77" d="M1377,476.3c-5,0-7.9,10.2-7.9,10.3v.3c.2,1.4,1,2.6,2.3,3.2,3.5,1.8,7.7,1.8,11.2,0,1.3-.6,2.2-1.8,2.3-3.2h0c0-.3-2.9-10.6-7.9-10.6"/>
  <path class="st75" d="M1382.4,490.1c1.3-.6,2.2-1.8,2.3-3.2h0c-.6-2.3-1.5-4.5-2.7-6.5-.7-.6-1.6-.9-2.5-.9-5,0-7.9,10.2-7.9,10.3v.5c3.4,1.6,7.4,1.5,10.8-.2"/>
  <g class="st78">
    <g class="st26">
      <path class="st79" d="M1388.1,500.5c-3.4,1.8-7.5,1.8-10.9,0-3-1.7-3-4.6,0-6.3,3.4-1.7,7.5-1.7,10.9,0,3,1.7,3,4.6,0,6.3"/>
    </g>
  </g>
  <path d="M1307.4,443.5v31.6c0,.3.1.5.4.7l.8.4c.1,0,.3.1.4.1.1,0,.3,0,.4-.1l.6-.4c.3-.2.5-.5.5-.9v-31.4h-3.1Z"/>
  <path class="st77" d="M1309,412.9c-7.5,0-11.9,36.6-12,36.8v.2s0,.1,0,.1h0c0,1.8,1.2,3.6,3.5,4.9,4.7,2.7,12.2,2.7,16.9,0,2.3-1.3,3.4-3,3.5-4.8h0c0-.5-4.4-37.3-12-37.3"/>
  <path class="st75" d="M1317.4,455c2.3-1.3,3.4-3,3.5-4.8h0c0-.4-2.6-21.7-7.1-31.9h0c-7.5,0-11.9,36.6-12,36.8v.3s0,0,0,.1h0c4.7,2,11.4,1.8,15.6-.6"/>
  <g class="st78">
    <g class="st33">
      <path class="st79" d="M1335.9,470c-4.7-2.7-12.4-2.7-17.1,0-1.6.8-2.8,2.2-3.4,3.9h-6.8v2.2h6.8c.6,1.6,1.8,3,3.4,3.8,4.7,2.7,12.4,2.7,17.1,0s4.7-7.2,0-9.9"/>
    </g>
  </g>
  <polygon class="st76" points="570.4 871.7 512.4 838.2 611.1 781.2 669.1 814.7 570.4 871.7"/>
  <g class="st28">
    <g>
      <path class="st76" d="M669.4,816l-.6.3c-1.3.6-2.5,1.4-3.6,2.2-1.2.8-2.3,1.7-3.3,2.8-3.2,1.2-6.2,2.7-9.1,4.5v-22.2c3.1,2.6,6.4,4.8,10,6.6,2.3,1.1,5.1,2,7.1,3.7l.3,1.5s0,0,0,.1h0c-.5.3-.7.4-.7.5"/>
      <path class="st76" d="M602.3,785.6c3.1-1.9,6.6-3.8,9.9-5.9l2.5,1.7c.4.3.8.7,1.3,1,.9.6,1.9,1.1,2.7,1.7.3.2.6.4.9.5,3,1.9,5.9,3.8,8.9,5.6,3.9,2.4,8.2,3.9,12.2,5.9.6.5,1.2.9,1.9,1.2h-55.4v-3.2c.3-.2.6-.3.9-.5,4.7-2.9,9.6-5.2,14.3-8.1"/>
      <path class="st76" d="M650,827.2c-.2.2-2.8,2-3.3,2.6-10,4.1-18.8,10.5-28.5,15.4-5.4,2.7-10.5,5.9-15.8,8.8-4.7,2.5-9.7,5-13.3,8.9h-1.9v-65.5h54.3c2.1,1.7,4.5,3,7,4,.5.2,2.5,1.2,1.4.6.6.3,1.2.6,1.7.9l1.1.5v21.4c-1,.6-1.9,1.4-2.7,2.3"/>
      <path class="st76" d="M524,831.1c.7-.4,1.5-.8,2.2-1.2.7-.4,1.4-.9,2-1.5,11.8-6.6,22.9-14.8,35-20.7.9-.4,1.7-1,2.4-1.7.9-.3,1.7-.7,2.5-1.2.2,0,.4,0,.5,0,1.7-.6,3.4-1.4,4.9-2.3,2.2-1.2,4.3-2.7,6.1-4.4.1-.1.2-.3.4-.4h7.2v65.5h-34.7c-2.1-2-4.6-3.7-7.3-4.9-2.6-1.3-4.8-3.2-7.3-4.6-4.8-2.6-9.8-5-14.6-7.7-.5-.5-1-1-1.6-1.4v-12.1c.8-.3,1.6-.7,2.3-1.1"/>
      <path class="st76" d="M565.6,870.4c-3.6-2.2-7.1-4.6-10.4-7.1-.2-.1-.4-.2-.6-.3h32.3l-.6.4h-.3c-1.2.5-2.3,1-3.3,1.6-1.3.7-2.9,1.7-4.2,2.5-.7.4-4.2,2.4-5.7,4l-1.3.4-.5.3c-.7-.1-1.3-.3-1.9-.6-.7-.4-5.1-2.3-3.4-1.2"/>
      <path class="st76" d="M520.3,843.3c-2.5-1.7-5.2-3.1-8.1-4.1l-.5-1.2-.2-.4c1.5-.8,3.2-1.2,4.6-2,2.1-1.3,3.9-2.9,5.5-4.7v13.6c-.5-.4-.9-.7-1.4-1.1"/>
    </g>
  </g>
  <path d="M603.8,770.6v31.6c0,.3.2.5.4.7l.7.4c.1,0,.3.1.4.1.1,0,.3,0,.4-.1l.6-.3c.3-.2.5-.5.5-.9v-31.4h-3.1Z"/>
  <path class="st77" d="M605.3,740c-7.5,0-11.9,36.6-12,36.8v.3s0,0,0,.1c0,1.7,1.2,3.5,3.5,4.8,4.7,2.7,12.2,2.7,16.9,0,2.3-1.3,3.5-3,3.5-4.8h0c0-.5-4.5-37.3-12-37.3"/>
  <path class="st75" d="M613.8,782.1c2.3-1.3,3.5-3,3.5-4.8h0c0-.4-2.6-21.7-7.1-31.9h0c-7.5,0-11.9,36.6-12,36.8,0,0,0,.1,0,.2v.2s0,0,0,.1h0c4.7,2,11.4,1.8,15.6-.6"/>
  <g class="st78">
    <g class="st32">
      <path class="st79" d="M632.2,797.2c-4.7-2.7-12.4-2.7-17.1,0-1.6.8-2.8,2.2-3.4,3.9h-6.7v2.2h6.8c.6,1.6,1.8,3,3.4,3.8,4.7,2.7,12.4,2.7,17.1,0s4.7-7.2,0-9.9"/>
    </g>
  </g>
  <path d="M538.1,826.9h-2v10.6c0,.4.2.7.5.9l1,.6c.3.2.7.2,1.1,0l.8-.5c.4-.2.7-.7.7-1.2v-10.4h-2.1Z"/>
  <path class="st77" d="M538.1,816.5c-5,0-7.9,10.2-7.9,10.3v.3c.2,1.4,1,2.6,2.3,3.2,3.5,1.8,7.7,1.8,11.2,0,1.3-.6,2.1-1.8,2.3-3.2h0c0-.3-3-10.6-7.9-10.6"/>
  <path class="st75" d="M543.6,830.3c1.3-.6,2.2-1.8,2.3-3.2h0c-.6-2.3-1.5-4.5-2.7-6.5-.7-.5-1.6-.9-2.5-.9-5,0-7.9,10.2-7.9,10.3v.3c0,0,0,.1,0,.2,3.4,1.6,7.4,1.5,10.8-.2"/>
  <g class="st78">
    <g class="st30">
      <path class="st79" d="M549.3,840.7c-3.4,1.7-7.5,1.7-10.9,0-3-1.7-3-4.6,0-6.3,3.4-1.7,7.5-1.7,10.9,0,3,1.8,3,4.6,0,6.3"/>
    </g>
  </g>
  <path d="M585.4,837.9h-2v10.7c0,.4.2.7.5.9l1,.6c.3.2.7.2,1.1,0l.8-.5c.4-.2.7-.7.7-1.2v-10.5h-2.1Z"/>
  <path class="st77" d="M585.4,827.5c-5,0-7.9,10.2-7.9,10.3v.3c.2,1.4,1,2.6,2.3,3.2,3.5,1.8,7.7,1.8,11.2,0,1.3-.6,2.1-1.8,2.3-3.2h0c0-.3-3-10.6-7.9-10.6"/>
  <path class="st75" d="M590.9,841.3c1.3-.6,2.1-1.8,2.3-3.2h0c-.6-2.3-1.5-4.5-2.7-6.5-.7-.5-1.6-.9-2.5-.9-5,0-7.9,10.2-7.9,10.3v.3c0,0,0,.1,0,.2,3.4,1.6,7.4,1.5,10.8-.2"/>
  <g class="st78">
    <g class="st27">
      <path class="st79" d="M596.6,851.7c-3.4,1.7-7.5,1.7-10.9,0-3-1.7-3-4.6,0-6.3,3.4-1.7,7.5-1.7,10.9,0,3,1.7,3,4.6,0,6.3"/>
    </g>
  </g>
  <path d="M624.8,813.6h-2v10.6c0,.4.2.7.5.9l1,.6c.3.2.7.2,1.1,0l.8-.5c.4-.2.7-.7.7-1.2v-10.4h-2.1Z"/>
  <path class="st77" d="M624.8,803.3c-5,0-7.9,10.2-7.9,10.3v.3c.2,1.4,1.1,2.6,2.3,3.2,3.5,1.8,7.7,1.8,11.2,0,1.3-.6,2.1-1.8,2.3-3.2h0c0-.3-3-10.6-7.9-10.6"/>
  <path class="st75" d="M630.3,817c1.3-.6,2.1-1.8,2.3-3.2h0c-.6-2.3-1.5-4.5-2.7-6.5-.7-.6-1.6-.9-2.5-.9-5,0-7.9,10.2-7.9,10.3v.5c3.4,1.6,7.4,1.5,10.8-.2"/>
  <g class="st78">
    <g class="st31">
      <path class="st79" d="M636,827.4c-3.4,1.7-7.5,1.7-10.9,0-3-1.7-3-4.6,0-6.3,3.4-1.7,7.5-1.7,10.9,0,3,1.7,3,4.6,0,6.3"/>
    </g>
  </g>
  <path d="M580.6,797.6h-3v16c0,.6.3,1.1.8,1.3l1.5.8c.5.3,1.1.3,1.6,0l1.2-.7c.6-.4,1-1.1,1-1.8v-15.7h-3Z"/>
  <path class="st77" d="M592.4,784c0,13.6-5.3,21.2-11.8,21.2s-11.8-7.8-11.8-21.2,5.3-21.2,11.8-21.2,11.8,7.6,11.8,21.2"/>
  <path class="st75" d="M592.4,784c0-7.4-1.6-13-4-16.5-.3,0-.6,0-.9,0-6.5,0-11.8,7.8-11.8,21.2s1.6,12.9,4.1,16.5h.9c6.5,0,11.8-7.6,11.8-21.2"/>
  <g class="st78">
    <g class="st29">
      <path class="st79" d="M597.2,818.5c-4.7,2.7-12.4,2.7-17.1,0s-4.7-7.2,0-9.9,12.4-2.7,17.1,0,4.7,7.2,0,9.9"/>
    </g>
  </g>
  <polygon class="st76" points="1358.4 740.7 1300.4 707.2 1399.1 650.2 1457.1 683.7 1358.4 740.7"/>
  <g class="st34">
    <g>
      <path class="st76" d="M1457.4,685l-.6.3c-1.3.6-2.5,1.4-3.6,2.2-1.2.8-2.3,1.7-3.3,2.8-3.2,1.2-6.2,2.7-9.1,4.5v-22.2c3.1,2.6,6.4,4.8,10,6.6,2.3,1.1,5.1,2,7.1,3.7l.3,1.5h0c0,.1,0,.1,0,.1-.5.3-.7.4-.7.5"/>
      <path class="st76" d="M1390.3,654.6c3.1-1.9,6.6-3.8,9.9-5.9l2.5,1.7c.4.3.8.7,1.3,1,.9.6,1.9,1.1,2.7,1.7.3.2.6.4.9.5,3,1.9,5.9,3.8,8.9,5.6,3.9,2.4,8.2,3.9,12.2,5.9.6.5,1.2.9,1.9,1.2h-55.4v-3.2c.3-.2.6-.3.9-.5,4.7-2.9,9.6-5.2,14.3-8.1"/>
      <path class="st76" d="M1438,696.2c-.2.2-2.8,2-3.3,2.6-10,4.1-18.8,10.5-28.4,15.4-5.4,2.7-10.5,5.9-15.8,8.8-4.7,2.5-9.7,5-13.3,8.9h-1.9v-65.5h54.3c2.1,1.7,4.5,3,7,4,.5.2,2.5,1.2,1.4.6.6.3,1.2.6,1.7.9l1.1.5v21.4c-1,.6-1.9,1.4-2.7,2.3"/>
      <path class="st76" d="M1312,700.1c.7-.4,1.5-.8,2.2-1.2.7-.4,1.4-.9,2-1.5,11.8-6.6,22.9-14.8,35-20.7.9-.4,1.7-1,2.4-1.7.9-.3,1.7-.7,2.5-1.2.2,0,.4,0,.5,0,1.7-.6,3.4-1.4,4.9-2.3,2.2-1.2,4.3-2.7,6.1-4.4.1-.1.2-.3.4-.4h7.2v65.5h-34.7c-2.1-2-4.6-3.7-7.3-4.9-2.6-1.3-4.8-3.2-7.3-4.6-4.8-2.6-9.8-5-14.6-7.7-.5-.5-1-1-1.6-1.4v-12.1c.8-.3,1.6-.7,2.3-1.1"/>
      <path class="st76" d="M1353.6,739.4c-3.6-2.2-7.1-4.6-10.4-7.1-.2-.1-.4-.2-.6-.3h32.3l-.6.4h-.3c-1.2.5-2.3,1-3.3,1.6-1.3.7-2.9,1.7-4.2,2.5-.7.4-4.2,2.4-5.7,4l-1.3.4-.5.3c-.7-.1-1.3-.3-1.9-.6-.7-.4-5.1-2.3-3.4-1.2"/>
      <path class="st76" d="M1308.3,712.3c-2.5-1.7-5.2-3.1-8.1-4.1l-.5-1.2-.2-.4c1.5-.8,3.2-1.2,4.6-2,2.1-1.3,3.9-2.9,5.6-4.7v13.6c-.5-.4-.9-.7-1.4-1.1"/>
    </g>
  </g>
  <path d="M1391.8,639.6v31.6c0,.3.2.5.4.7l.7.4c.1,0,.3.1.4.1.1,0,.3,0,.4-.1l.6-.3c.3-.2.5-.5.5-.9v-31.4h-3.1Z"/>
  <path class="st77" d="M1393.3,609c-7.5,0-11.9,36.6-12,36.8v.3s0,0,0,.1c0,1.7,1.2,3.5,3.5,4.8,4.7,2.7,12.2,2.7,16.9,0,2.3-1.3,3.4-3,3.5-4.8h0c0-.5-4.4-37.3-12-37.3"/>
  <path class="st75" d="M1401.8,651.1c2.3-1.3,3.4-3,3.5-4.8h0c0-.4-2.6-21.7-7.1-31.9h0c-7.5,0-11.9,36.6-12,36.8v.5h0c4.7,2,11.4,1.8,15.6-.6"/>
  <g class="st78">
    <g class="st35">
      <path class="st79" d="M1420.2,666.2c-4.7-2.7-12.4-2.7-17.1,0-1.6.8-2.8,2.2-3.4,3.9h-6.7v2.2h6.8c.6,1.6,1.8,3,3.4,3.8,4.7,2.7,12.4,2.7,17.1,0s4.7-7.2,0-9.9"/>
    </g>
  </g>
  <path d="M1326.1,695.9h-2v10.6c0,.4.2.7.5.9l1,.6c.3.2.7.2,1.1,0l.8-.5c.4-.2.7-.7.7-1.2v-10.4h-2.1Z"/>
  <path class="st77" d="M1326.1,685.5c-5,0-7.9,10.2-7.9,10.3v.3c.2,1.4,1,2.6,2.3,3.2,3.5,1.8,7.7,1.8,11.2,0,1.3-.6,2.1-1.8,2.3-3.2h0c0-.3-3-10.6-7.9-10.6"/>
  <path class="st75" d="M1331.6,699.3c1.3-.6,2.2-1.8,2.3-3.2h0c-.6-2.3-1.5-4.5-2.7-6.5-.7-.5-1.6-.9-2.5-.9-5,0-7.9,10.2-7.9,10.3v.3c0,0,0,.1,0,.2,3.4,1.6,7.4,1.5,10.8-.2"/>
  <g class="st78">
    <g class="st20">
      <path class="st79" d="M1337.3,709.7c-3.4,1.7-7.5,1.7-10.9,0-3-1.7-3-4.6,0-6.3,3.4-1.7,7.5-1.7,10.9,0,3,1.8,3,4.6,0,6.3"/>
    </g>
  </g>
  <path d="M1373.4,706.9h-2v10.7c0,.4.2.7.5.9l1,.6c.3.2.7.2,1.1,0l.8-.5c.4-.2.7-.7.7-1.2v-10.5h-2.1Z"/>
  <path class="st77" d="M1373.4,696.5c-5,0-7.9,10.2-7.9,10.3v.3c.2,1.4,1,2.6,2.3,3.2,3.5,1.8,7.7,1.8,11.2,0,1.3-.6,2.1-1.8,2.3-3.2h0c0-.3-3-10.6-7.9-10.6"/>
  <path class="st75" d="M1378.9,710.3c1.3-.6,2.1-1.8,2.3-3.2h0c-.6-2.3-1.5-4.5-2.7-6.5-.7-.5-1.6-.9-2.5-.9-5,0-7.9,10.2-7.9,10.3v.3c0,0,0,.1,0,.2,3.4,1.6,7.4,1.5,10.8-.2"/>
  <g class="st78">
    <g class="st18">
      <path class="st79" d="M1384.6,720.7c-3.4,1.7-7.5,1.7-10.9,0-3-1.7-3-4.6,0-6.3,3.4-1.7,7.5-1.7,10.9,0,3,1.7,3,4.6,0,6.3"/>
    </g>
  </g>
  <path d="M1412.8,682.6h-2v10.6c0,.4.2.7.5.9l1,.6c.3.2.7.2,1.1,0l.8-.5c.4-.2.7-.7.7-1.2v-10.4h-2.1Z"/>
  <path class="st77" d="M1412.8,672.3c-5,0-7.9,10.2-7.9,10.3v.3c.2,1.4,1.1,2.6,2.3,3.2,3.5,1.8,7.7,1.8,11.2,0,1.3-.6,2.1-1.8,2.3-3.2h0c0-.3-3-10.6-7.9-10.6"/>
  <path class="st75" d="M1418.3,686c1.3-.6,2.1-1.8,2.3-3.2h0c-.6-2.3-1.5-4.5-2.7-6.5-.7-.6-1.6-.9-2.5-.9-5,0-7.9,10.2-7.9,10.3v.5c3.4,1.6,7.4,1.5,10.8-.2"/>
  <g class="st78">
    <g class="st22">
      <path class="st79" d="M1424,696.4c-3.4,1.7-7.5,1.7-10.9,0-3-1.7-3-4.6,0-6.3,3.4-1.7,7.5-1.7,10.9,0,3,1.7,3,4.6,0,6.3"/>
    </g>
  </g>
  <path d="M1368.6,666.6h-3v16c0,.6.3,1.1.8,1.3l1.5.8c.5.3,1.1.3,1.6,0l1.2-.7c.6-.4,1-1.1,1-1.8v-15.7h-3Z"/>
  <path class="st77" d="M1380.4,653c0,13.6-5.3,21.2-11.8,21.2s-11.8-7.8-11.8-21.2,5.3-21.2,11.8-21.2,11.8,7.6,11.8,21.2"/>
  <path class="st75" d="M1380.4,653c0-7.4-1.6-13-4-16.5-.3,0-.6,0-.9,0-6.5,0-11.8,7.8-11.8,21.2s1.6,12.9,4.1,16.5c.3,0,.6,0,.9,0,6.5,0,11.8-7.6,11.8-21.2"/>
  <g class="st78">
    <g class="st25">
      <path class="st79" d="M1385.2,687.5c-4.7,2.7-12.4,2.7-17.1,0s-4.7-7.2,0-9.9,12.4-2.7,17.1,0,4.7,7.2,0,9.9"/>
    </g>
  </g>
  <polygon class="st76" points="1612.9 530.2 1554.9 496.7 1653.6 439.7 1711.6 473.2 1612.9 530.2"/>
  <g class="st23">
    <g>
      <path class="st76" d="M1644.8,444.1c3.1-1.9,6.6-3.8,9.9-5.9.8.6,1.7,1.1,2.5,1.7.4.3.8.7,1.3,1,.9.6,1.9,1.1,2.7,1.7.3.2.6.4.9.5,3,1.9,5.9,3.8,8.9,5.6,3.9,2.4,8.2,3.9,12.2,5.9.6.5,1.2.9,1.9,1.2h-55.4v-3.2c.3-.1.6-.3.9-.5,4.7-2.9,9.6-5.2,14.3-8.1"/>
      <path class="st76" d="M1692.5,485.7c-.2.2-2.8,2-3.3,2.6-10,4.1-18.8,10.5-28.4,15.4-5.4,2.7-10.5,5.9-15.8,8.8-4.7,2.5-9.7,5-13.3,8.9h-1.9v-65.4h54.3c2.1,1.7,4.5,3,7,4,.5.2,2.5,1.2,1.4.6.6.3,1.2.6,1.7.9l1.1.5v21.4c-1,.6-1.9,1.4-2.7,2.3"/>
      <path class="st76" d="M1566.5,489.5c.7-.4,1.5-.8,2.2-1.2.7-.4,1.4-.9,2-1.5,11.8-6.6,22.9-14.8,35-20.7.9-.4,1.7-1,2.4-1.7.9-.3,1.7-.7,2.5-1.2.2,0,.4,0,.5-.1,1.7-.6,3.4-1.4,4.9-2.4,2.2-1.2,4.3-2.7,6.1-4.4.1-.1.2-.3.4-.4h7.2v65.5h-34.7c-2.1-2-4.6-3.7-7.3-4.9-2.6-1.3-4.8-3.2-7.3-4.6-4.8-2.6-9.8-5-14.6-7.7-.5-.5-1-1-1.6-1.4v-12.1c.8-.3,1.6-.7,2.3-1.1"/>
      <path class="st76" d="M1608.1,528.9c-3.6-2.2-7.1-4.6-10.4-7.1-.2-.1-.4-.2-.6-.3h32.3l-.6.4h-.3c-1.2.5-2.3,1-3.3,1.6-1.3.7-2.9,1.7-4.2,2.5-.7.4-4.2,2.4-5.7,4l-1.3.4-.5.3c-.7-.1-1.3-.3-1.9-.6-.7-.4-5.1-2.3-3.4-1.2"/>
      <path class="st76" d="M1562.8,501.8c-2.5-1.7-5.2-3.1-8.1-4.1l-.5-1.2-.2-.4c1.5-.8,3.2-1.2,4.6-2,2.1-1.3,3.9-2.9,5.6-4.7v13.6c-.5-.4-.9-.7-1.4-1.1"/>
    </g>
  </g>
  <path d="M1580.6,485.4h-2v10.6c0,.4.2.7.5.9l1,.6c.3.2.7.2,1.1,0l.8-.5c.4-.2.7-.7.7-1.2v-10.4h-2.1Z"/>
  <path class="st77" d="M1580.6,475c-5,0-7.9,10.2-7.9,10.3v.3c.2,1.4,1,2.6,2.3,3.2,3.5,1.8,7.7,1.8,11.2,0,1.3-.6,2.1-1.8,2.3-3.2h0c0-.3-3-10.6-7.9-10.6"/>
  <path class="st75" d="M1586.1,488.8c1.3-.6,2.2-1.8,2.3-3.2h0c-.6-2.3-1.5-4.5-2.7-6.5-.7-.5-1.6-.9-2.5-.9-5,0-7.9,10.2-7.9,10.3v.3c0,0,0,.1,0,.2,3.4,1.6,7.4,1.5,10.8-.2"/>
  <g class="st78">
    <g class="st21">
      <path class="st79" d="M1591.8,499.2c-3.4,1.7-7.5,1.7-10.9,0-3-1.7-3-4.6,0-6.3,3.4-1.7,7.5-1.7,10.9,0,3,1.8,3,4.6,0,6.3"/>
    </g>
  </g>
  <path d="M1627.9,496.4h-2v10.6c0,.4.2.7.5.9l1,.6c.3.2.7.2,1.1,0l.8-.5c.4-.2.7-.7.7-1.2v-10.4h-2.1Z"/>
  <path class="st77" d="M1627.9,486c-5,0-7.9,10.2-7.9,10.3v.3c.2,1.4,1,2.6,2.3,3.2,3.5,1.8,7.7,1.8,11.2,0,1.3-.6,2.1-1.8,2.3-3.2h0c0-.3-3-10.6-7.9-10.6"/>
  <path class="st75" d="M1633.4,499.8c1.3-.6,2.1-1.8,2.3-3.2h0c-.6-2.3-1.5-4.5-2.7-6.5-.7-.5-1.6-.9-2.5-.9-5,0-7.9,10.2-7.9,10.3v.3c0,0,0,.1,0,.2,3.4,1.6,7.4,1.5,10.8-.2"/>
  <g class="st78">
    <g class="st24">
      <path class="st79" d="M1639.1,510.2c-3.4,1.7-7.5,1.7-10.9,0-3-1.7-3-4.6,0-6.3,3.4-1.7,7.5-1.7,10.9,0,3,1.7,3,4.6,0,6.3"/>
    </g>
  </g>
  <path d="M1623.1,456.1h-3v16c0,.6.3,1.1.8,1.3l1.5.8c.5.3,1.1.3,1.6,0l1.2-.7c.6-.4,1-1.1,1-1.8v-15.7h-3Z"/>
  <path class="st77" d="M1635,442.5c0,13.6-5.3,21.2-11.8,21.2s-11.8-7.8-11.8-21.2,5.3-21.2,11.8-21.2,11.8,7.6,11.8,21.2"/>
  <path class="st75" d="M1635,442.5c0-7.4-1.6-13-4-16.5-.3,0-.6,0-.9,0-6.5,0-11.8,7.8-11.8,21.2s1.6,12.9,4.1,16.5c.3,0,.6,0,.9,0,6.5,0,11.8-7.6,11.8-21.2"/>
  <g class="st78">
    <g class="st19">
      <path class="st79" d="M1639.7,477c-4.7,2.7-12.4,2.7-17.1,0s-4.7-7.2,0-9.9,12.4-2.7,17.1,0,4.7,7.2,0,9.9"/>
    </g>
  </g>
  <path class="st1" d="M1249.6,575.4s8-43,51-43,49,29,49,29"/>
  <g>
    <polygon class="st4" points="1248.5 544.1 1244 546.7 1238.6 543.6 1243.1 541 1248.5 544.1"/>
    <polygon class="st4" points="1248.5 584.9 1244 587.5 1238.6 584.4 1243.1 581.8 1248.5 584.9"/>
    <polygon class="st6" points="1248.5 566.3 1244 568.9 1244 546.7 1248.5 544.1 1248.5 566.3"/>
    <polygon class="st6" points="1248.5 607.1 1244 609.7 1244 587.5 1248.5 584.9 1248.5 607.1"/>
    <path class="st3" d="M1233,605v-40.8c0-6.1,5.7-14.4,11-17.5h0l-5.4-3.1c-5.3,3.1-11,11.3-11,17.5v40.8c0,2.3.8,4,2.1,5l5.7,3.3c-1.4-1-2.4-2.7-2.4-5.2Z"/>
    <path class="st7" d="M1244,587.5h0s0,0,0,0l-5.4-3.1s0,0,0,0v7.9c1.7-2.1,3.6-3.8,5.5-4.9Z"/>
    <path class="st5" d="M1244,587.5c-1.9,1.1-3.8,2.8-5.5,4.9v-7.9s0-14.1,0-14.1c1.7,0,3.6-.4,5.5-1.5v-5.4s0-16.8,0-16.8c-5.3,3.1-11,11.3-11,17.5v40.8c0,2.5.9,4.2,2.4,5.2.2.2.5.3.8.4,0,0,0,0,.1,0,2.1.9,5,.6,7.7-1v-22.2s0,0,0,0Z"/>
  </g>
</svg>
`;
